import {Component, ElementRef, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {forkJoin, Subject, subscribeOn, takeUntil} from "rxjs";
import {SearchState, SearchStateService} from "../_core/services/search-state-v2.service";
import {
  ActionPasser,
  BahamutHelper,
  Checkbox,
  Dropdown,
  ErrorMessages,
  GMList,
  Grandmaster,
  Logger, TabsContainer,
  Validator,
  OverlayService,
  Utils, BuildWatcher
} from "lo-bahamut";
import {SearchService} from "../_core/services/search.service";
import {SearchV2Service} from "../_core/services/search-v2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {LoadingSpinnerService} from "../_core/services/loading-spinner.service";
import {HandlebarsService} from "../services/handlebars.service";
import {CareFindrTenantConfigurationService} from "../_core/api/services/care-findr-tenant-configuration.service";
import {CareFindrTenantConfigurationService as CareFindrTenantConfig } from "../_core/apiV2/services/care-findr-tenant-configuration.service";
import {ProviderSearchService} from "../_core/apiV2/services/provider-search.service";
import {Router} from "@angular/router";
import {CURRENT_TENNANT} from "../app.component";
import {SearchResultService} from "../services/search-result.service";
import {Subscription} from "rxjs";
import * as Handlebars from "handlebars"
import {level} from "lo-bahamut-v1/types";
import {option} from "../search-start-v2/search-start-v2.component";
import {CareFindrConfigApiService} from "../_core/api/services/care-findr-config-api.service";
import {ProviderResponseOfPractitionerRoles} from "../_core/api/models/provider-response-of-practitioner-roles";
import {FacilityResponseOfOrgAffiliations} from "../_core/api/models/facility-response-of-org-affiliations";
import {ProviderResponseOfPractitionerRoles as ProviderResponseOfPractitionerRolesV2} from "../_core/apiV2/models/provider-response-of-practitioner-roles";
import {FacilityResponseOfOrgAffiliations as FacilityResponseOfOrgAffiliationsV2} from "../_core/apiV2/models/facility-response-of-org-affiliations";
import {BasicProviderSearchQuery} from "../_core/apiV2/models/basic-provider-search-query";
import {BasicProviderSearchQuery as BasicProviderSearchQueryV2} from "../_core/apiV2/models/basic-provider-search-query";
import {isNull, omitBy} from "lodash-es";
import {BasicOrganizationSearchQuery} from "../_core/apiV2/models/basic-organization-search-query";
import {BasicOrganizationSearchQuery as BasicOrganizationSearchQueryV2} from "../_core/apiV2/models/basic-organization-search-query";
// import {SearchCardData,SearchResultCardAdapterService} from "../_core/services/searchResultCard/search-result-card-adapter.service";
import {
  AggregateRootOfPractitionerPractitionerRole,
  AggregateRootOfFacilityOrganizationAffiliation,
  FacilityResponseOfMasteredLocations,
  ProviderResponseOfMasteredLocations, OrganizationAffiliationsGroupedByLocation, PractitionerRolesGroupedByLocation,
  CreateTicketRequest,
} from 'src/app/_core/apiV2/models';

import {
  ProviderSearchRequest, FacilitySearchRequest,
} from 'src/app/_core/apiV2/models'

import {
  AggregateRootOfPractitionerPractitionerRole as AggregateRootOfPractitionerPractitionerRoleV2,
  AggregateRootOfFacilityOrganizationAffiliation as AggregateRootOfFacilityOrganizationAffiliationV2,
  FacilityResponseOfMasteredLocations as FacilityResponseOfMasteredLocationsV2,
  ProviderResponseOfMasteredLocations as ProviderResponseOfMasteredLocationsV2,
  OrganizationAffiliationsGroupedByLocation as OrganizationAffiliationsGroupedByLocationV2,
  PractitionerRolesGroupedByLocation as PractitionerRolesGroupedByLocationV2,
} from 'src/app/_core/apiV2/models';
// import {
//   SearchResultCardExpandInformationData, SearchResultCardExpandTab1AdapterService
// } from "../_core/services/searchResultCard/search-result-card-expand-tab1-adapter.service";
// import {processedTelecom, SearchResultCardExpandTab2Service} from "../_core/services/searchResultCard/search-result-card-expand-tab2.service";
import {processedTelecom, SearchResultCardExpandTab2V2Service } from "../_core/services/searchResultCardV2/search-result-card-expand-tab2-v2.service";
import { extractBhAndCrisisFromRelation } from "../_core/services/searchResultCardV2/behavioral-health.utils";
import {PrintPdfService} from "../_core/services/print-pdf.service";
import {
  SearchResultCardAdapterV2Service, SearchCardData
} from "../_core/services/searchResultCardV2/search-result-card-adapter-v2.service";
import {
  SearchResultCardExpandTab1AdapterV2Service, SearchResultCardExpandInformationData
} from "../_core/services/searchResultCardV2/search-result-card-expand-tab1-adapter-v2.service";
import {Title} from "@angular/platform-browser"
import {PrintPdfV2Service} from "../_core/services/print-pdf-v2.service";
import {DOCUMENT} from "@angular/common";
import {
  applyPcpSpecialtySelection as applyPcpSpecialtySelectionToDropdown,
  getActiveVisibleEnabledRef,
  getRefsByJsonId,
  hideFilterPill,
} from "../_core/services/pcp-specialty-utils";
import {TicketsService} from "../_core/apiV2/services/tickets.service";
import { DefaultLocationService } from "../_core/services/default-location.service";


@Component({
  selector: 'app-search-results-v2',
  templateUrl: './search-results-v2.component.html',
  styleUrls: ['./search-results-v2.component.scss']
})
export class SearchResultsV2Component implements  OnInit{
  // private url: string = "../../assets/search-result-page.hbs";
  // private url: string = "../../assets/search-result-page-mddoh.hbs";
  // private url: string = "../../assets/search-result-page-champion.hbs";
  // private url: string = "../../assets/search-result-page-villagecare.hbs";
  private url: string = "../../assets/search-result-page-champion.hbs";
  private _data: any;
  private templateResponse: any;
  isPlanDropDownEnabled = true;
  isIPASectionEnabled = false; // champion tenant spesific
  isSpecialityHeaderNeedToChange = false;
  isClearingFilters: boolean = false;
  destroyed$ = new Subject<void>();
  private previousScrollTop: number = 0;
  planOptions: option[] = [];
  specialtyOptions: level[] = [];
  genderOptions: option[] = [];
  languageOptions: option[] = [];

  searchState: SearchState = {
    Query: {
      sortBy: 'distance-asc',
    },
    Extra: {},
  };

  printState: SearchState = {
    Query: {},
    Extra: {},
  };

  printProviderReady: boolean = false;
  printFacilityReady: boolean = false;
  imgPaths: string[] = [];
  currentTab!: string;

  providerSearchResults: ProviderResponseOfPractitionerRolesV2 = {};
  facilitySearchResults: FacilityResponseOfOrgAffiliationsV2 = {};
  providerFilterSearchResults: ProviderResponseOfPractitionerRolesV2 = {};
  facilityFilterSearchResults: FacilityResponseOfOrgAffiliationsV2 = {};
  providerPrintResults: ProviderResponseOfPractitionerRoles = {};
  facilityPrintResults: FacilityResponseOfOrgAffiliations = {};
// result card
  providerCardDataArray: any ;
  facilityCardDataArray: any ;

  itemsPerPageProvider: number = 10;
  currentPageProvider: number = 1;

  itemsPerPageFacility: number = 10;
  currentPageFacility: number = 1;
  isLoading: boolean = false;


  private searchResultData!: Subscription;
  private searchTriggerTimer: ReturnType<typeof setTimeout> | null = null;
  private activeSearchSubscription?: Subscription;

  // elements UK variables
  languageDropdownUK: any;
  genderDropdownUK: any;
  telehealthDropdownUK: any;
  anpCheckboxUK: any;
  acceptingDropdownUK: any;
  handicapCheckboxUK: any;
  pcpCheckboxUK: any;
  specialistCheckboxUK: any;
  telehealthCheckboxUK: any;
  homeVisitsCheckboxUK: any;
  adacompCheckboxUK: any;
  languagePillUK: any;
  genderPillUK: any;
  telehealthPillUK: any;
  anpPillUk: any;
  acceptingPillUK: any
  handicapPillUK: any;
  pcpPillUk: any;
  specialistPillUK: any;
  telehealthCheckboxPillUK: any;
  homeVisitsPillUK: any;
  adacompPillUK: any;

  //Behaviour Health filters variables
  agegroupDropdownUK: any;
  agegroupPillUK: any;
  locDropdownUK: any;
  locPillUK: any;
  crisisDropdownUK: any;
  crisisPillUK: any;
  affiliationDropdownUK: any;
  affiliationPillUK: any;
  conditionsDropdownUK: any;
  conditionsPillUK: any;

  // detail call
  detailCallSubscription: Subscription;
  providerDetailsData!: ProviderResponseOfMasteredLocationsV2;
  facilityDetailsData!: FacilityResponseOfMasteredLocationsV2
  isExpanded: boolean = false;
  providerInfoData: SearchResultCardExpandInformationData;
  facilityInfoData: SearchResultCardExpandInformationData;
  locationData: {
    telecomData: processedTelecom;
    root: OrganizationAffiliationsGroupedByLocationV2 | PractitionerRolesGroupedByLocationV2;
    behaviorHealth: {
      communication: string[];
      affiliation: string[];
      ageLimit: string[];
      conditionsTreated: string[];
      levelOfCare: string[];
    };
    crisisServices: Array<{
      communication: string[];
      type: string[];
      telecom: { phone: string[]; email: string[] };
      coverageArea: string[];
      availableTime: any[];
    }>;
  }[];
  relationsGroupedByLocation!:
    | OrganizationAffiliationsGroupedByLocationV2[]
    | PractitionerRolesGroupedByLocationV2[];

  // result tab json varibale
  resultsTabsJSON: any;

  printProviderResultBtnUk: any;
  printFacilityResultBtnUk: any;
  filterBlockUk: any;
  tabChange: TabsContainer;

  showMoreDetailsData!:
    | FacilityResponseOfMasteredLocations
    | ProviderResponseOfMasteredLocations;

  printAllResultsData!:
    | ProviderSearchRequest
    | FacilitySearchRequest;

  facilityTabUk: any;
  providerTabUk: any;

  private lastFocusedElement: HTMLElement | null = null;

  // page title
  defaultTitle: string = '';

  totalProviderResults: any = 0;
  totalFacilityResults: any = 0;

  isInitialSearh: boolean = true;
  isPreciseLocationChecked: boolean = !!this.searchStateService.getSearchCriteria().Query.isPreciseLocation;

  private readonly villageCarePlanClassMap: Record<string, string> = {
    'villagecaremax-managed-long-term-care-mltc': 'villagecare-mltc',
    'villagecaremax-medicare-total-advantage-plan-map': 'villagecare-mtap',
    'villagecaremax-medicare-health-advantage-plan-dsnp': 'villagecare-mhap',
    'villagecaremax-medicare-select-advantage-plan-hmo': 'villagecare-msap',
  };

  private readonly villageCarePlanClasses: string[] = Object.values(this.villageCarePlanClassMap);

  private reportIssueContext: { stableId: string; name: string } = { stableId: "", name: "" };
  private reportIssueNpi: string = "";
  private reportIssueLocationOptions: Array<{ value: string; description: string }> = [];
  private reportIssueFormValues: {
    issueType: string;
    issueTypeDescription: string;
    location: string;
    whatsIncorrect: string;
    correctInformation: string;
    knowledgeSource: string;
    knowledgeSourceDescription: string;
    knowledgeSourceOther: string;
    userName: string;
    userEmail: string;
  } = {
    issueType: "",
    issueTypeDescription: "",
    location: "",
    whatsIncorrect: "",
    correctInformation: "",
    knowledgeSource: "",
    knowledgeSourceDescription: "",
    knowledgeSourceOther: "",
    userName: "",
    userEmail: "",
  };


  public get data(): any { return this._data; }
  @ViewChild('gm') gm: Grandmaster;

  constructor(private searchService: SearchService,
              private searchV2Service: SearchV2Service,
              public actionPasser: ActionPasser,
              public gmList: GMList,
              private loadingSpinnerService: LoadingSpinnerService,
              public logger: Logger,
              private lobhelper: BahamutHelper,
              public errorMessages: ErrorMessages,
              public grandmaster: Grandmaster,
              public validator: Validator,
              private hbs: HandlebarsService,
              private searchStateService: SearchStateService,
              private configApiService: CareFindrConfigApiService,
              private tenantConfigService: CareFindrTenantConfigurationService,
              private tenantConfigServiceV2: CareFindrTenantConfig,
              private providerSearchService: ProviderSearchService,
              private router: Router,
              private searchResultService: SearchResultService,
              private searchCardAdapter: SearchResultCardAdapterV2Service,
              private searchResultCardExpandTab1AdapterService: SearchResultCardExpandTab1AdapterV2Service,
              private searchResultCardExpandTab2Service: SearchResultCardExpandTab2V2Service,
              private printService: PrintPdfV2Service,
              public overlay: OverlayService,
              public utill: Utils,
              private titleService: Title,
              public buildWatcher: BuildWatcher,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: Document,
              private ticketsService: TicketsService,
              private defaultLocationService: DefaultLocationService
  ) {
  }

  // Helper functions to avoid code duplication
  private getTelehealthFilterStatus(): { telehealthFilter: string | undefined; isTeleHealthValue: boolean } {
    const query = this.searchStateService.getSearchCriteria()?.Query;
    let telehealthFilter: string | undefined;

    if (query && 'telehealthFilter' in query) {
      telehealthFilter = (query as any).telehealthFilter;
    }

    const isTeleHealthValue =
      !!telehealthFilter &&
      CURRENT_TENNANT === 'mddoh' &&
      telehealthFilter === 'Telehealth Services';

    return { telehealthFilter, isTeleHealthValue };
  }

  private getDynamicPageName(baseName: string): string {
    if (CURRENT_TENNANT === 'champion') {
      return `champion-${baseName}`;
    } else if (CURRENT_TENNANT === 'villagecare') {
      return `villagecare-${baseName}`;
    } else if (CURRENT_TENNANT === 'mddoh') {
      return `mddoh-${baseName}`;
    } else if (CURRENT_TENNANT === 'centerlight') {
      return `centerlight-${baseName}`;
    }
    return baseName;
  }

  async ngOnInit() {
    this.defaultTitle = this.titleService.getTitle();
    const searchTextTranslations: any = {
      "en" : "Search results",
      "es" : "Resultados de búsqueda",
      "ru" : "Результаты поиска",
      "ht" : "Rezilta rechèch",
      "zh" : "搜索结果"
    };
    const selectedLang = localStorage.getItem('translateLanguageTo') || 'en';
    const translatedText = searchTextTranslations[selectedLang] || searchTextTranslations['en'];
    const newTitle = `CareFinDr: ${translatedText}`;
    this.titleService.setTitle(newTitle);
    this.document.documentElement.lang = localStorage.getItem('translateLanguageTo') || 'en';
    // Trigger screen reader announcement
    setTimeout(() => {
      const liveRegion = document.getElementById('page-title-announcer');
      if (liveRegion) {
        liveRegion.textContent = newTitle;
      }
    }, 100);
    await this.seedDefaultVillageCareLocation();

    // this.loadingSpinnerService.showLoader();
    // const tenantJSON = this.tenantConfigServiceV2.getTenantBluePrint({page_name: 'result-tab', tenant: CURRENT_TENNANT});

    // forkJoin([tenantJSON])
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe({
    //     next: ([componentJsResponse]) => {
    //       let response: any = {}
    //       if (typeof componentJsResponse === "string") {
    //         response = JSON.parse(componentJsResponse);
    //         console.log("response",response);
    //       } else {
    //         response = componentJsResponse;
    //       }
    //       // this._data = response.componentsConfig;
    //       this.errorMessages.defaultErrorMessages = response.errorMessages;
    //       console.log(this.data);
    //     },
    //     error: (err) => {
    //       if (err.status === 403) {
    //         console.error('You are not authorized to view this', err);
    //         this.router.navigate(['error-handler'], {state: { msg:"Access denied"}});
    //       } else {
    //         console.error('Please try again later or contact support.', err);
    //       }
    //     },
    //     complete: () => {
    //       this.loadingSpinnerService.hideLoader();
    //     }
    //   });


    this.searchStateService.searchState$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((state) => {
        this.searchState = state;
      });
    this.searchState = this.searchStateService.getSearchCriteria();
    this.printState = this.searchStateService.getSearchCriteria();

    //TODO: To be revised after configuration driven UI is implemented
    if(CURRENT_TENNANT === 'centerlight' || CURRENT_TENNANT === 'mddoh' || CURRENT_TENNANT === 'champion')
      this.isSpecialityHeaderNeedToChange = true;
      this.isPlanDropDownEnabled = false;

    if(CURRENT_TENNANT === 'champion')
      this.isIPASectionEnabled = true;

    //TODO: To be revised after configuration driven UI is implemented
    if(CURRENT_TENNANT === 'mddoh')
      this.isSpecialityHeaderNeedToChange = true;


      //get existing results and search state passed from search-start
      this.providerSearchResults = this.searchV2Service.getCurrentProviderResults();
      this.facilitySearchResults = this.searchV2Service.getCurrentFacilityResults();
    // }
    if (this.providerSearchResults?.providers) {
      this.providerCardDataArray = {
        providers: this.mapSearchResults<AggregateRootOfPractitionerPractitionerRoleV2>(
          this.providerSearchResults.providers,
          (item) => this.searchCardAdapter.adaptProvider(item)
        )
      };
    }
    if (this.facilitySearchResults?.facilities) {
      this.facilityCardDataArray = {
        facilities: this.mapSearchResults<AggregateRootOfFacilityOrganizationAffiliationV2>(
          this.facilitySearchResults.facilities,
          (item) => this.searchCardAdapter.adaptFacility(item)
        )
      };
    }

    // getting the largeText value from the localStorage for resizing the text.
    if(localStorage.getItem('largeText') && (localStorage.getItem('largeText') === 'true')){
      const body = document.body;
      this.renderer.addClass(body, 'text-large');
    }

    // Ensure default preferred language is set
    if (!localStorage.getItem('preferredLanguage')) {
      localStorage.setItem('preferredLanguage', 'preferredLanguageEnglish');
    }

    this.getCareLoaDrJson();

    this.buildPreface();

    this.actionPasser.groupEmitter$.pipe(takeUntil(this.destroyed$)).subscribe((group: any) => {
      // console.log(group)
      if (group !== undefined && Object.keys(group).length !== 0) {
        switch (group[0].groupName) {
          // find the first non-disabled (0/empty) tab and focus it
          case "focusResultsTab":
            this.focusResultsTab(group);
            break;

          //search-required groups
          case "updateDistanceDropdown":
            if(!this.isInitialSearh) {
              this.updateDistanceDropdown(group);
            }
            break;
          case "updateDistanceSlider":
            this.updateDistanceSlider(group);
            break;
          case "checkedPreciseLocation":
            this.checkedPreciseLocation(group);
            break;

          //search-filter groups
          case "selectedLanguage":
            this.selectedLanguage(group);
            break;
          case "selectedGender":
            this.selectedGender(group);
            break;
          case "selectedTelehealth":
            this.selectedTelehealth(group);
            break;
          case "checkedAccepting":
            this.checkedAccepting(group);
            break;
          case "acceptingDropdownUpdate":
            this.acceptingDropdownUpdate(group);
            break;
          case "checkedHandicap":
            this.checkedHandicap(group);
            break;
          case "checkedPCP":
            this.checkedPCP(group);
            break;
          case "checkedSpecialist":
            this.checkedSpecialist(group);
            break;
          case "checkedTelehealth":
            this.checkedTelehealth(group);
            break;
          case "checkedHomevisits":
            this.checkedHomevisits(group);
            break;
          case "checkedAdacomp":
            this.checkedAdacomp(group);
            break;
          case "resetFilterLanguage":
            this.resetFilterLanguage(group);
            break;
          case "resetFilterGender":
            this.resetFilterGender(group);
            break;
          case "resetFilterTelehealth":
            this.resetFilterTelehealth(group);
            break;
          case "resetANPCheckbox":
            this.resetANPCheckbox(group);
            break;
          case "resetFilterAccepting":
            this.resetFilterAccepting(group);
            break;
          case "resetHandicapCheckbox":
            this.resetHandicapCheckbox(group);
            break;
          case "resetPCPCheckbox":
            this.resetPCPCheckbox(group);
            break;
          case "resetSpecialistCheckbox":
            this.resetSpecialistCheckbox(group);
            break;
          case "resetTelehealthCheckbox":
            this.resetTelehealthCheckbox(group);
            break;
          case "resetHomevisitsCheckbox":
            this.resetHomevisitsCheckbox(group);
            break;
          case "resetAdacompCheckbox":
            this.resetAdacompCheckbox(group);
            break;
          case "selectedAgegroup":
            this.selectedAgegroup(group);
            break;
          case "resetFilterAgegroup":
            this.resetFilterAgegroup(group);
            break;
          case "selectedLoc":
            this.selectedLoc(group);
            break;
          case "resetFilterLoc":
            this.resetFilterLoc(group);
            break;
          case "selectedCrisis":
            this.selectedCrisis(group);
            break;
          case "resetFilterCrisis":
            this.resetFilterCrisis(group);
            break;
          case "selectedAffiliation":
            this.selectedAffiliation(group);
            break;
          case "resetFilterAffiliation":
            this.resetFilterAffiliation(group);
            break;
          case "selectedConditions":
            this.selectedConditions(group);
            break;
          case "resetFilterConditions":
            this.resetFilterConditions(group);
            break;
          case "clearFilters":
            this.clearFilters(group);
            break;
          case "showMoreProviderDetails":
            this.toggleProviderFacilityDetails(group, "tab_provider");
            break;
          case "showMoreFacilityDetails":
            this.toggleProviderFacilityDetails(group, "tab_facility");
            break;
          case "show-more-details": {
            var showMoreButtonElem = this.gmList.gmList[group[0].uniqueKey].elementRef;
            var detailsTabsRef = this.gmList.gmList[group[1].uniqueKey].reference;
            var printButtonRef = this.gmList.gmList[group[2].uniqueKey].reference;
            var result = showMoreButtonElem?.closest(".result");
            if (detailsTabsRef.hide === false){
              result?.classList.add("details-open");
              printButtonRef.hide = false;
            }
            else {
              result?.classList.remove("details-open");
              printButtonRef.hide = true;
            }
            break;
          }
          case "handleInputChange":
            if(!this.isInitialSearh) {
              this.handleInputChange(group);
            }
            break;
          case "handlePlanChange":
            this.handlePlanChange(group);
            break;
          case "enableDisableIPA":
            // the plan dropdown is still empty while the page builds; clearing here would wipe the IPAs carried over from the home page
            if(!this.isInitialSearh) {
              this.enableDisableIPA(group);
            }
            break;
          case "printResults":
              this.printResults(group);
            break;
          case "resultTabSwitch":
            this.currentTab = this.gmList.gmList[group[0].uniqueKey].reference.jsonid;
            break;
          // show/hide filters and sidebar on edit click when in 'mobile' view
          case "edit-search-criteria":
            var filtersElem = this.gmList.gmList[group[1].uniqueKey].elementRef;
            var sidebarElem = this.gmList.gmList[group[2].uniqueKey].elementRef;
            var breadcrumbsElem = this.gmList.gmList[group[3].uniqueKey].elementRef;
            if (filtersElem?.classList.contains("show")){
              filtersElem?.classList.remove("show");
              sidebarElem?.classList.remove("show");
              sidebarElem?.removeAttribute("style");
            }
            else {
              filtersElem?.classList.add("show");
              sidebarElem?.classList.add("show");
              var totalMoveDown = breadcrumbsElem?.offsetHeight! + filtersElem?.offsetHeight!;
              sidebarElem?.setAttribute("style", "height: calc(100dvh - "+totalMoveDown+"px)");
            }
            break;
          // champion tenant: "Update Search" hides the edit search panel the same way the edit button closes it
          case "close-search-criteria": {
            const filtersElem = this.gmList.gmList[group[1].uniqueKey].elementRef;
            const sidebarElem = this.gmList.gmList[group[2].uniqueKey].elementRef;
            filtersElem?.classList.remove("show");
            sidebarElem?.classList.remove("show");
            sidebarElem?.removeAttribute("style");
            break;
          }
          case "printDetailProvider":
            this.printDetailProvider(group);
            break;
          case "printDetailFacility":
            this.printDetailFacility(group);
            break;
          case "pagination":
            this.pagination(group);
            break;

          case "reportIssue":
            this.reportIssue(group);
            break;

          case "handleIssueTypeChange":
            this.handleIssueTypeChange(group);
            break;

          case "handleKnowledgeSourceChange":
            this.handleKnowledgeSourceChange(group);
            break;

          case "validateReportIssueForm":
            this.validateReportIssueForm(group);
            break;

          case "submitReportIssue":
            this.submitReportIssue(group);
            break;

          case "resetTextSize":{
            const body = document.body;
            if (body.classList.contains('text-large')) {
              this.renderer.removeClass(body, 'text-large');
            }
            localStorage.setItem('largeText', 'false');
            break;
          }
          case "largeTextSize":{
            const body = document.body;
            if (!body.classList.contains('text-large')) {
              this.renderer.addClass(body, 'text-large');
            }
            localStorage.setItem('largeText', 'true');
            break;
          }
          case "languageButton": {
            // Identify which language button was clicked
            const btnRef = this.gmList.gmList[group[0].uniqueKey].reference;
            const clickedId = btnRef?.jsonid || btnRef?.id || '';
            const selected = clickedId || 'preferredLanguageEnglish';
            const translateLanguageTo = group[0].passedInfo[0];

            // Store selection in localStorage
            localStorage.setItem('preferredLanguage', selected);
            localStorage.setItem('translateLanguageTo', translateLanguageTo);

            // Update UI to reflect selection
            try {
              setTimeout(() => this.applyPreferredLanguageUI(), 0);
            } catch {}
            window.location.reload();
            break;
          }
        }
      }
    });
  }

  // Add method to update language UI in all containers
  private updateLanguageUIInAllContainers(selectedId: string): void {
    try {
      // Update language buttons in main content area
      let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
      let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
      const mainLangUk = this.lobhelper.getDesiredChildUK(cfMainUk, "careFindrLangResizeContainer");
      if (mainLangUk) {
        this.applyLanguageHighlight(mainLangUk, selectedId);
      }
    } catch (error) {
      console.warn('Error updating language UI in containers:', error);
    }
  }

  // this method to apply the language UI
  private applyPreferredLanguageUI(): void {
    try {
      const selectedId = localStorage.getItem('preferredLanguage') || 'preferredLanguageEnglish';

      const cfRightUk = this.lobhelper.getDesiredChildUK("0", "cf_right");
      const cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
      const langUk = this.lobhelper.getDesiredChildUK(cfMainUk, 'careFindrLangResizeContainer');

      const ids = [
        'preferredLanguageEnglish',
        'preferredLanguageCreole',
        'preferredLanguageRussian',
        'preferredLanguageChinese',
        'preferredLanguageSpanish'
      ];

      ids.forEach(id => {
        try {
          const btnUk = this.lobhelper.getDesiredChildUK(langUk, id);
          if (!btnUk) return;

          const btnRef: any = this.gmList.gmList[btnUk]?.reference;
          const btnEl: any = this.gmList.gmList[btnUk]?.elementRef;

          if (!btnRef) return;

          // Update classes
          let classes: string[] = Array.isArray(btnRef.classes)
            ? [...btnRef.classes]
            : (typeof btnRef.classes === 'string' ? btnRef.classes.split(' ').filter(Boolean) : []);

          if (!classes.includes('preferred-language-btn')) {
            classes.push('preferred-language-btn');
          }

          const isActive = id === selectedId;
          if (isActive) {
            if (!classes.includes('active-language')) classes.push('active-language');
            if (btnEl) {
              btnEl.setAttribute('aria-pressed', 'true');
            }
          } else {
            classes = classes.filter(c => c !== 'active-language');
            if (btnEl) {
              btnEl.setAttribute('aria-pressed', 'false');
            }
          }

          btnRef.classes = classes;

        } catch (e) {
          console.warn(`Could not update button ${id}:`, e);
        }
      });
    } catch (error) {
      console.warn('Error applying preferred language UI:', error);
    }
  }

  private mapSearchResults<T>(
    items: T[] | undefined,
    adapterFn: (item: T) => SearchCardData | undefined
  ): any[] {
    if (!items) return [];

    return items.map((item: T) => {
      const cardData = adapterFn(item);

      // Derive EPSDT indicator from heads[].identifier[].attrs.epsdtIndicator (first match)
      let epsdtIndicator: string | undefined;
      try {
        const heads = (item as any)?.heads as any[] | undefined;
        if (Array.isArray(heads)) {
          for (const h of heads) {
            const identifiers = h?.identifier as any[] | undefined;
            if (Array.isArray(identifiers)) {
              for (const id of identifiers) {
                const val = id?.attrs?.epsdtIndicator;
                if (val) {
                  epsdtIndicator = val;
                  break;
                }
              }
            }
            if (epsdtIndicator) break;
          }
        }
      } catch {}

      // Derive Board Certified pill label from relations[0].specialty[].attrs.boardCertified
      let boardCertifiedLabel: string | undefined;
      try {
        let specialties = (item as any)?.relations?.[0]?.specialty;
        if (!specialties || specialties.length === 0) {
          specialties = (item as any)?.relations?.[0]?.location?.[0]?.specialty;
        }

        if (Array.isArray(specialties)) {
          for (const s of specialties) {
            const bc = s?.attrs?.boardCertified;
            if (bc === 'Board Certified') {
              boardCertifiedLabel = 'Board Certified';
              break;
            }
          }
        }
      } catch {}

      const firstRelation = (item as any)?.relations?.[0];
      const relationLocation = firstRelation?.location;
      const normalizedLocation = Array.isArray(relationLocation)
        ? relationLocation[0]
        : relationLocation;
      const normalizedCharacteristics =
        firstRelation?.characteristic || normalizedLocation?.characteristic;

      const minDistance = (item as any)?.relations?.[0]?.meta?.min_distance ?? cardData?.extras?.MinDistance;

      return {
        ...cardData,
        formattedName: this.capitalizeEachWord(cardData?.extras?.Name || ''),
        formattedDistance: this.truncateDistance(minDistance),
        cardDataArray: this.getCardDataArray(cardData),
        acceptingPatients: (['newpt', 'newchpt', 'newmcdpt'].includes(firstRelation?.acceptingPatients?.code)
          ? firstRelation?.acceptingPatients?.display
          : undefined) || (['newpt', 'newchpt', 'newmcdpt'].includes(normalizedLocation?.acceptingPatients?.code)
          ? normalizedLocation?.acceptingPatients?.display
          : undefined),
        boardCertifiedLabel: boardCertifiedLabel,
        // Expose first location's fields for Additional Information pills
        locationAccessibility: normalizedLocation?.accessibility || firstRelation?.characteristic,
        practitionerCodes: firstRelation?.code || normalizedLocation?.code,
        characteristics: normalizedCharacteristics,
        epsdtIndicator: epsdtIndicator,
        stableId: (item as any).stableId,
        stableIdHash: (item as any).stableIdHash,
        heads: (item as any).heads,
        network: (Array.isArray(firstRelation?.network) && firstRelation?.network.length > 0)
          ? firstRelation?.network
          : normalizedLocation?.network
      };
    });
  }


  toggleProviderFacilityDetails(group: any, currentTab: string) {
    const targetId = group[0]?.id;
    if (!targetId) return;

    const contentDiv = document.getElementById(targetId);
    if (!contentDiv) return;

    const isExpanded = contentDiv.classList.contains('expanded');
    const npiID = group[0].passedInfo[0];
    const lat = group[0].passedInfo[1];
    const lon = group[0].passedInfo[2];
    const locationStableIdHash = group[0].passedInfo[3] ? group[0].passedInfo[3] : undefined;
    const detailsTabsUK = group[1].uniqueKey;

    // 🔹 If already expanded, just collapse and skip API calls
    if (isExpanded) {
      contentDiv.classList.remove('expanded');
      this.loadingSpinnerService.hideLoader();
      return;
    }

    // 🔹 If collapsed, expand and fetch details
    this.loadingSpinnerService.showLoader();

    const { isTeleHealthValue } = this.getTelehealthFilterStatus();

    if (currentTab === 'tab_provider') {
      this.detailCallSubscription = this.searchV2Service
        .getProviderDetails(npiID, lat, lon, locationStableIdHash)
        .subscribe((data: ProviderResponseOfMasteredLocationsV2 | undefined) => {
          if (data) {
            if(this.getTelehealthFilterStatus()){
              this.showMoreDetailsData = {
                ...data,
                telehealthFilter: this.searchStateService.getSearchCriteria()?.Query.telehealthFilter
              };
            }else{
              this.showMoreDetailsData = data;
            }

            this.relationsGroupedByLocation = data.providers![0].relations!;
            this.getProcessedData();

            const providerResponse = data;
            if (providerResponse?.providers) {
              const aggregateRootProvider = providerResponse.providers[0];
              this.providerInfoData =
                this.searchResultCardExpandTab1AdapterService.adaptProvider(
                  aggregateRootProvider
                );

              let detailsTabsRef = this.gmList.gmList[detailsTabsUK].reference;
              const previouslyActiveTabUk = detailsTabsRef.getCurrentTabUk?.();
              const tabToActivate =
                previouslyActiveTabUk ||
                this.lobhelper.getDesiredChildUK(
                  detailsTabsUK,
                  'tab_location_information'
                );
              if (
                tabToActivate &&
                this.gmList.gmList[detailsTabsUK]?.reference?.changeTab
              ) {
                this.gmList.gmList[detailsTabsUK].reference.changeTab(tabToActivate);
              }
            }

            const pageName = this.getDynamicPageName('show-more-partial-tab');

            // Compile template + inject data
            // this.searchResultData = this.searchResultService.getSearchResultJson("../../assets/hbs_partials/provider-facility-show-more-partial.hbs").subscribe(response => {
            this.searchResultData = this.tenantConfigServiceV2.getTenantBluePrint({ page_name: pageName, tenant: CURRENT_TENNANT,'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en'}).subscribe((response) => {
                if (response == null) return;
                const res = decodeURIComponent(Array.prototype.map.call(atob(response), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
                const template = Handlebars.compile(res);
                const renderedHtml = template({
                  tabInfo: this.providerInfoData,
                  locationsData: this.locationData,
                  tab: this.currentTab,
                  isIPASectionEnabled: CURRENT_TENNANT === 'champion',
                  isTeleHealthValue: isTeleHealthValue
                });
                let data = JSON.parse(renderedHtml);
                let detailsTabsRef = this.gmList.gmList[detailsTabsUK].reference;

                if (detailsTabsRef.children.length > 0) {
                  detailsTabsRef.children.forEach(async (childUk: string) => {
                    var childGm = this.gmList.gmList[childUk];
                    await childGm.reference.clearForDestroy();
                  });
                  detailsTabsRef.children = [];
                  detailsTabsRef.tabs = [];
                }
                detailsTabsRef.addChildrenToThisView(data);
              });

            this.isExpanded = true;
            this.providerDetailsData = data;
          }

          contentDiv.classList.add('expanded');
          this.loadingSpinnerService.hideLoader();
        });
    } else if (currentTab === 'tab_facility') {
      this.detailCallSubscription = this.searchV2Service
        .getFacilityDetails(npiID)
        .subscribe((data: FacilityResponseOfMasteredLocationsV2 | undefined) => {
          if (data) {
            this.showMoreDetailsData = data;
            this.relationsGroupedByLocation = data.facilities![0].relations!;
            this.getProcessedData();

            const facilityResponse = data;
            if (facilityResponse?.facilities) {
              const aggregateRootFacility = facilityResponse.facilities[0];
              this.facilityInfoData =
                this.searchResultCardExpandTab1AdapterService.adaptFacility(
                  aggregateRootFacility
                );

              let detailsTabsRef = this.gmList.gmList[detailsTabsUK].reference;
              const previouslyActiveTabUk = detailsTabsRef.getCurrentTabUk?.();
              const tabToActivate =
                previouslyActiveTabUk ||
                this.lobhelper.getDesiredChildUK(
                  detailsTabsUK,
                  'tab_location_information'
                );
              if (
                tabToActivate &&
                this.gmList.gmList[detailsTabsUK]?.reference?.changeTab
              ) {
                this.gmList.gmList[detailsTabsUK].reference.changeTab(tabToActivate);
              }
            }

            const tenantsWithCustomTab = ['champion', 'villagecare', 'centerlight', 'mddoh'];
            // Compile template + inject data
            // this.searchResultData = this.searchResultService.getSearchResultJson("../../assets/hbs_partials/provider-facility-show-more-partial.hbs").subscribe(response => {
              this.searchResultData = this.tenantConfigServiceV2.getTenantBluePrint({ page_name: tenantsWithCustomTab.includes(CURRENT_TENNANT) ? `${CURRENT_TENNANT}-show-more-partial-tab` : 'show-more-partial-tab', tenant: CURRENT_TENNANT,}).subscribe((response) => {
                if (response == null) return;
                const res = decodeURIComponent(Array.prototype.map.call(atob(response), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
                const template = Handlebars.compile(res);
                const renderedHtml = template({
                  tabInfo: this.facilityInfoData,
                  locationsData: this.locationData,
                  tab: this.currentTab,
                  isIPASectionEnabled: CURRENT_TENNANT === 'champion',
                  isTeleHealthValue: (CURRENT_TENNANT === 'mddoh') ? isTeleHealthValue : false
                });
                let data = JSON.parse(renderedHtml as string);
                let detailsTabsRef = this.gmList.gmList[detailsTabsUK].reference;

                if (detailsTabsRef.children.length > 0) {
                  detailsTabsRef.children.forEach(async (childUk: string) => {
                    var childGm = this.gmList.gmList[childUk];
                    await childGm.reference.clearForDestroy();
                  });
                  detailsTabsRef.children = [];
                  detailsTabsRef.tabs = [];
                }
                detailsTabsRef.addChildrenToThisView(data);
              });

            this.isExpanded = true;
            this.facilityDetailsData = data;
          }

          contentDiv.classList.add('expanded');
          this.loadingSpinnerService.hideLoader();
        });
    }
  }

  // Update the applyLanguageHighlight method to be more robust
  private applyLanguageHighlight(containerUk: any, selectedId: string): void {
    const ids = [
      'preferredLanguageEnglish',
      'preferredLanguageCreole',
      'preferredLanguageRussian',
      'preferredLanguageChinese',
      'preferredLanguageSpanish'
    ];

    ids.forEach(id => {
      try {
        const btnUk = this.lobhelper.getDesiredChildUK(containerUk, id);
        if (!btnUk) return;

        const btnRef: any = this.gmList.gmList[btnUk]?.reference;
        const btnEl: any = this.gmList.gmList[btnUk]?.elementRef;

        if (!btnRef) return;

        // Update classes
        let classes: string[] = Array.isArray(btnRef.classes)
          ? [...btnRef.classes]
          : (typeof btnRef.classes === 'string' ? btnRef.classes.split(' ').filter(Boolean) : []);

        if (!classes.includes('preferred-language-btn')) {
          classes.push('preferred-language-btn');
        }

        const isActive = id === selectedId;
        if (isActive) {
          if (!classes.includes('active-language')) classes.push('active-language');
          btnEl?.setAttribute?.('aria-pressed', 'true');
        } else {
          classes = classes.filter(c => c !== 'active-language');
          btnEl?.setAttribute?.('aria-pressed', 'false');
        }

        btnRef.classes = classes;
      } catch (e) {
        console.warn(`Could not update button ${id} in container:`, e);
      }
    });
  }

  getProcessedData() {
    const relations = Array.isArray(this.relationsGroupedByLocation)
      ? this.relationsGroupedByLocation
      : [];

    this.locationData = relations.map((root) => {
      const svc = extractBhAndCrisisFromRelation(root);
      const relationLocation: any = (root as any)?.location;
      const normalizedLocation = Array.isArray(relationLocation)
        ? relationLocation[0]
        : relationLocation;
      const normalizedCharacteristic =
        (root as any)?.characteristic || normalizedLocation?.characteristic;
      const normalizedRoot: any = {
        ...(root as any),
        characteristic: normalizedCharacteristic,
      };

      return {
        root: normalizedRoot,
        telecomData: this.searchResultCardExpandTab2Service.processTelecom(
          normalizedLocation?.telecom || []
        ),
        behaviorHealth: svc.behaviorHealth,
        crisisServices: svc.crisisServices,
      };
    });
  }
  ngOnDestroy(): void {
    this.titleService.setTitle(this.defaultTitle);
    if (this.searchResultData) {
      this.searchResultData.unsubscribe();
    }
    if (this.searchTriggerTimer) {
      clearTimeout(this.searchTriggerTimer);
      this.searchTriggerTimer = null;
    }
    if (this.activeSearchSubscription) {
      this.activeSearchSubscription.unsubscribe();
    }
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  addToGrandmaster(viewRef: any, data: any) {
    console.log(data)
    this.grandmaster.addChildrenToThisView(viewRef, data);
    // this.firstLoad = false;
    // setTimeout(() =>{console.log("4")
    //   console.log(this.gmList.gmList)
    //   console.log(this.gmList.gmList[2])}, 0)
  }

  getCareLoaDrJson() {
    const { isTeleHealthValue } = this.getTelehealthFilterStatus();
    const resultsTabsName = this.getDynamicPageName('results-tabs');

    const partialPromises = [
      this.searchService.fetchPartialFromDB(resultsTabsName , 'resultsTabs'),
    ];
    Promise.all(partialPromises).then(() => {
      // TODO: Remove once the API changes are ready to load the hbs files
      // this.searchResultData = this.searchResultService.getSearchResultJson(this.url).subscribe(res => {
       this.searchResultData = this.tenantConfigServiceV2.getTenantBluePrint({page_name: `${CURRENT_TENNANT}-result-page`, tenant: CURRENT_TENNANT,'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en'}).subscribe(response => {
              if(response == null) return;
         const res = decodeURIComponent(Array.prototype.map.call(atob(response), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
              this.templateResponse = res;
            const template = Handlebars.compile(res);
        const renderedHtml = template({
          searchCriteria: this.searchStateService.getSearchCriteria(),
          locationText: this.searchStateService.getSearchCriteria().Extra.locationText,
          providerSearchResults: this.providerCardDataArray,
          totalProviderSearchResults: this.providerSearchResults?.total,
          facilitySearchResults: this.facilityCardDataArray,
          totalFacilitySearchResults: this.facilitySearchResults?.total,
          isTeleHealthValue: isTeleHealthValue,
          isPreciseLocation: this.isPreciseLocationChecked,
          currentSpecialtyDD: this.searchState.Extra.specialtyDD
        });
        // this.customLabels =  JSON.parse(renderedHtml).customLabels
        this._data = JSON.parse(renderedHtml).componentsConfig;

          this.errorMessages.defaultErrorMessages = JSON.parse(renderedHtml).errorMessages;

         this.buildWatcher.waitForBuildComplete().then(async resp => {
           this.isInitialSearh = false;
           this.applyChampionPlanStateSelection(this.searchState.Query.planState, undefined, false);
           this.isSearchEnabled();
           this.updateClearFiltersButtonVisibility();
           // Apply initial preferred language selection
           try {
             const selected = localStorage.getItem('preferredLanguage') || 'preferredLanguageEnglish';
             this.updateLanguageUIInAllContainers(selected);
           } catch (error) {
             console.warn('Error applying initial language selection:', error);
           }
         })
        });
        let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
        let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
        let resultTabsUk = this.lobhelper.getDesiredChildUK(cfMainUk, "results_tabs");
        this.providerTabUk = this.lobhelper.getDesiredChildUK(resultTabsUk, "tab_provider");
        this.facilityTabUk = this.lobhelper.getDesiredChildUK(resultTabsUk, "tab_facility");

        if(this.providerSearchResults?.total! == 0 && this.facilitySearchResults?.total! > 0){
          this.currentTab = 'tab_facility';
          setTimeout(() => {
            this.gmList.gmList[resultTabsUk].reference.changeTab(this.facilityTabUk, true);
          }, 700);
        } else {
          this.currentTab = 'tab_provider';
          setTimeout(() => {
            this.gmList.gmList[resultTabsUk].reference.changeTab(this.providerTabUk, true);
          }, 700);
        }

    }).catch((error) =>{
      console.log("error while loading partials", error)
    });
  }

  //search-required groups
  updateDistanceDropdown(group: any){
    let sliderRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let distanceDDRef = this.gmList.gmList[group[1].uniqueKey].reference;
    if(sliderRef.data == distanceDDRef.data) return;
    if (sliderRef.data != distanceDDRef.data) {
      if (distanceDDRef.componentRef.componentType == Dropdown) {
        distanceDDRef.checkboxes.forEach((cb: Checkbox) => {
          cb.checked = false;
        })
        distanceDDRef.data = [sliderRef.data];
      } else {
        distanceDDRef.data = sliderRef.data;
      }
    }
    if (distanceDDRef.data[0]) {
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          location: {
            ...this.searchState.Query.location,
            distance: (Array.isArray(distanceDDRef.data) ? distanceDDRef.data[0] : distanceDDRef.data).toString()
          },
        },
      });
      if(this.isClearingFilters) return;
      this.isSearchEnabled();
    }
  }

  handleInputChange(group: any) {
    let inputRef = this.gmList.gmList[group[0].uniqueKey].reference;

    if(this.searchState.Query.location?.distance == undefined){
      if (CURRENT_TENNANT === 'villagecare') {
        this.searchStateService.updateSearchCriteria({
          Query: {
            ...this.searchState.Query,
            location: {
              ...this.searchState.Query.location,
              distance: "5",
            },
          },
        });
      }else{
        this.searchStateService.updateSearchCriteria({
          Query: {
            ...this.searchState.Query,
            location: {
              ...this.searchState.Query.location,
              distance: "25",
            },
          },
        });
      }
    }
    if(inputRef.jsonid === "rs_location"){
      if(inputRef.data === ''){
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          location: {
            ...this.searchState.Query.location,
            latitude: undefined,
            longitude: undefined,
          },
          address: {
            city: undefined,
            state: undefined,
            postalCode: undefined,
          }
        },
        Extra: {
          ...this.searchState.Extra,
          locationText: undefined,
          locationSource: 'cleared',
        },
      });
      }else{
        this.searchStateService.updateSearchCriteria({
          Query: {
            ...this.searchState.Query,
            location: {
              ...this.searchState.Query.location,
              latitude: inputRef.data.geometry.location.lat() as unknown as string,
              longitude: inputRef.data.geometry.location.lng() as unknown as string,
            },
            address: {
              city: inputRef.data.cities,
              state: inputRef.data.state,
              postalCode: inputRef.data.postalCode,
            }
          },
          Extra: {
            ...this.searchState.Extra,
            locationText: inputRef.data.formatted_address,
            locationSource: 'user',
          },
        });
      }
    } else if (inputRef.jsonid === "name_input") {
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          name: inputRef.data,
        },
      });
    } else if (inputRef.jsonid === "provider_or_speciality_dropdown") {
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          specialtiesV2: inputRef.data,
        },
      });
    } else if (inputRef.jsonid === "plan_dropdown" || (CURRENT_TENNANT === 'champion' && inputRef.jsonid === "plan_dropdown2")) {
      const canSendProgramType = Array.isArray(inputRef.data) && inputRef.data[0]?.trim?.().length > 0;

      const { programType, ...restQuery } = this.searchState.Query;

      this.searchStateService.updateSearchCriteria({
        Query: {
          ...restQuery,
          ...(canSendProgramType && { programType: inputRef.data }),
        },
      });
      if (CURRENT_TENNANT === 'villagecare') {
        const empty = !Array.isArray(inputRef.data) || inputRef.data.length === 0 || (inputRef.data.length === 1 && (!inputRef.data[0] || inputRef.data[0] === ''));
        this.updateBodyClassBySelectedPlan(inputRef.data[0]);
        if (empty) {
          setTimeout(() => {
            inputRef.setCustomErrorMessage('required');
            inputRef.cdRef.detectChanges();
          });
        } else if (!empty) {
          inputRef.clearErrorMessage();
        }
      }
    } else if (inputRef.jsonid === "rs_plan_state") {
      if(inputRef.data.length > 0 && inputRef.data[0] !== "") {
        this.searchState.Query.planState = inputRef.data;
      }else{
        this.searchState.Query.planState = undefined;
      }
      this.applyChampionPlanStateSelection(this.searchState.Query.planState, group[0]?.uniqueKey, true);
    }else if (inputRef.jsonid === "rs_provider_network") {
      if (inputRef.data.length > 0 && inputRef.data[0] !== "") {
        this.searchState.Query.siteNumbers = inputRef.data;
      } else {
        this.searchState.Query.siteNumbers = undefined;
      }
    }else if (CURRENT_TENNANT === "villagecare") {
      if (["provider_or_speciality_dropdown2", "provider_or_speciality_dropdown3", "provider_or_speciality_dropdown4"]
        .includes(inputRef.jsonid)) {
        const empty = !Array.isArray(inputRef.data) || inputRef.data.length === 0 || (inputRef.data.length === 1 && (!inputRef.data[0] || inputRef.data[0] === ''));
        if(!empty){
          this.searchState.Query.specialtiesV2 = inputRef.data;
        } else {
          this.searchState.Query.specialtiesV2 = [];
        }
        this.searchStateService.updateSearchCriteria(this.searchState);
      }
    }
    this.updateSearchButtonState(group);
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  private updateBodyClassBySelectedPlan(planValue?: string): void {
    const body = this.document.body;
    if (!body) return;

    this.villageCarePlanClasses.forEach((className) => {
      this.renderer.removeClass(body, className);
    });

    if (!planValue) return;

    const mappedClass = this.villageCarePlanClassMap[planValue];
    if (mappedClass) {
      this.renderer.addClass(body, mappedClass);
    }
  }

  private applyChampionPlanStateSelection(planState: string[] | undefined, anchorUk?: string, selectAllActive = false): void {
    if (CURRENT_TENNANT !== 'champion') return;

    const requiredSearchUk = anchorUk
      ? this.lobhelper.getDesiredParentUK(anchorUk, 'required_search') || anchorUk
      : this.getRequiredSearchUk();
    const planDropdownRef = this.getRequiredSearchChildRef(requiredSearchUk, 'plan_dropdown');
    const planDropdown2Ref = this.getRequiredSearchChildRef(requiredSearchUk, 'plan_dropdown2');
    const providerNetworkRef = this.getRequiredSearchChildRef(requiredSearchUk, 'rs_provider_network');
    const selectedState = Array.isArray(planState) ? planState[0] : undefined;
    // Preserve values already submitted from home; only recompute when the user actively changes planState here.
    const savedProgramType = this.getDropdownValues({ data: this.searchState.Query.programType });
    if (!selectAllActive) {
      // Re-applying the plan dropdowns below briefly empties them, which would make enableDisableIPA wipe the IPAs
      // carried over from the home page. Their change events land asynchronously, so keep the guard up for a moment.
      this.isRestoringPlanState = true;
      setTimeout(() => (this.isRestoringPlanState = false), 500);
    }

    if (selectedState === 'CA') {
      // lo-bahamut's Dropdown resets .data to [] whenever .hide is (re)assigned, so toggle hide/disabled
      // BEFORE reapplying the selected values, never after.
      this.setDropdownState(planDropdownRef, false, false);
      this.setDropdownState(planDropdown2Ref, true, true);
      const selectedValues = selectAllActive ? this.selectAllDropdownOptions(planDropdownRef) : savedProgramType;
      this.applyDropdownValues(planDropdownRef, selectedValues);
      this.setDropdownDisabled(planDropdownRef, selectedValues.length === 0);
      this.searchState.Query.programType = selectedValues;
      this.updateProviderNetworkState(providerNetworkRef, planDropdownRef);
    } else if (selectedState === 'NV') {
      this.setDropdownState(planDropdownRef, true, true);
      this.setDropdownState(planDropdown2Ref, false, false);
      const selectedValues = selectAllActive ? this.selectAllDropdownOptions(planDropdown2Ref) : savedProgramType;
      this.applyDropdownValues(planDropdown2Ref, selectedValues);
      this.setDropdownDisabled(planDropdown2Ref, selectedValues.length === 0);
      this.searchState.Query.programType = selectedValues;
      this.updateProviderNetworkState(providerNetworkRef, planDropdown2Ref);
    } else {
      this.setDropdownState(planDropdownRef, false, true);
      this.setDropdownState(planDropdown2Ref, true, true);
      this.clearDropdownSelection(planDropdownRef);
      this.clearDropdownSelection(planDropdown2Ref);
      this.updateProviderNetworkState(providerNetworkRef, undefined);
    }

    this.searchStateService.updateSearchCriteria(this.searchState);
  }

  private getRequiredSearchUk(): string | undefined {
    const cfLeftUk = this.lobhelper.getDesiredChildUK('1', 'cf_left');
    const sidebarUk = this.lobhelper.getDesiredChildUK(cfLeftUk, 'cf_sidebar');
    return this.lobhelper.getDesiredChildUK(sidebarUk, 'required_search');
  }

  private getRequiredSearchChildRef(requiredSearchUk: string | undefined, childId: string): any {
    if (!requiredSearchUk) return undefined;
    const childUk = this.lobhelper.getDesiredChildUK(requiredSearchUk, childId);
    const entry = childUk ? this.gmList.gmList[childUk] : undefined;
    if (entry?.reference && !Array.isArray(entry.reference.options)) {
      // Backend-generated option lists aren't always hydrated onto the component yet; fall back to the raw JSON config.
      entry.reference.__configOptions = (entry.json?.inputs as any)?.options;
    }
    return entry?.reference;
  }

  private setDropdownState(dropdownRef: any, hide: boolean, disabled: boolean): void {
    if (!dropdownRef) return;
    // Assigning .hide resets the Dropdown's internal .data to [] (lo-bahamut quirk) - call this
    // before restoring any selected values, never after.
    dropdownRef.hide = hide;
    dropdownRef.disabled = disabled;
    dropdownRef.cdRef?.detectChanges?.();
  }

  private setDropdownDisabled(dropdownRef: any, disabled: boolean): void {
    if (!dropdownRef) return;
    dropdownRef.disabled = disabled;
    dropdownRef.cdRef?.detectChanges?.();
  }

  private getDropdownValues(dropdownRef: any): string[] {
    return Array.isArray(dropdownRef?.data)
      ? dropdownRef.data.filter((value: any) => typeof value === 'string' ? value.trim().length > 0 : !!value)
      : [];
  }

  private applyDropdownValues(dropdownRef: any, values: string[]): void {
    if (!dropdownRef || values.length === 0) return;
    dropdownRef.data = values;
    if (Array.isArray(dropdownRef.checkboxes)) {
      dropdownRef.checkboxes.forEach((checkbox: any) => checkbox.checked = values.includes(checkbox.value));
    }
    dropdownRef.cdRef?.detectChanges?.();
  }

  private selectAllDropdownOptions(dropdownRef: any): string[] {
    if (!dropdownRef) return [];
    const options = Array.isArray(dropdownRef.options) ? dropdownRef.options : dropdownRef.__configOptions;
    if (!Array.isArray(options)) return [];
    const values = this.getDropdownValues({ data: options.map((option: any) => option?.value) });
    if (values.length === 0) return [];
    this.applyDropdownValues(dropdownRef, values);
    return values;
  }

  private clearDropdownSelection(dropdownRef: any): void {
    if (!dropdownRef) return;
    dropdownRef.data = [];
    if (Array.isArray(dropdownRef.selected)) dropdownRef.selected = [];
    if (Array.isArray(dropdownRef.checkboxes)) {
      dropdownRef.checkboxes.forEach((checkbox: any) => checkbox.checked = false);
    }
    dropdownRef.cdRef?.detectChanges?.();
  }

  private updateProviderNetworkState(providerNetworkRef: any, planRef: any): void {
    const hasPlanSelection = this.getDropdownValues(planRef).length > 0;
    if (providerNetworkRef) {
      providerNetworkRef.disabled = !hasPlanSelection;
      if (!hasPlanSelection) {
        providerNetworkRef.data = [];
        this.searchState.Query.siteNumbers = undefined;
      }
      providerNetworkRef.cdRef?.detectChanges?.();
    }
  }

  private isRestoringPlanState = false;

  enableDisableIPA(group: any) {
    if (this.isRestoringPlanState) return;
    let planRef = this.gmList.gmList[group[0].uniqueKey].reference;
   let providerNetworkRef = this.gmList.gmList[group[1].uniqueKey].reference;
    if (
      Array.isArray(planRef.data) &&
      planRef.data.length > 0 &&
      !(planRef.data.length === 1 && planRef.data[0] === '')
    ) {
     providerNetworkRef.disabled = false;
   }else{
      providerNetworkRef.disabled = true;
      providerNetworkRef.data = [];
      this.searchState.Query.siteNumbers = undefined;
      this.searchStateService.updateSearchCriteria(this.searchState);
    }
  }

  handlePlanChange(group: any) {
    let planRef = this.gmList.gmList[group[0].uniqueKey].reference;//the emitted element is the plan dropdown default to 0th index
    let specialtyRef1 = this.gmList.gmList[group[1].uniqueKey].reference;
    let specialtyRef2 = this.gmList.gmList[group[2].uniqueKey].reference;
    let specialtyRef3 = this.gmList.gmList[group[3].uniqueKey].reference;
    let specialtyRef4 = this.gmList.gmList[group[4].uniqueKey].reference;

    let soecialtyParentUk = this.lobhelper.getDesiredParentUK(group[1].uniqueKey, "required_search");
    let nameInputUk = this.lobhelper.getDesiredChildUK(soecialtyParentUk, "name_input");
    let nameInputRef = this.gmList.gmList[nameInputUk].reference;
    if(CURRENT_TENNANT == 'villagecare'){
      nameInputRef.disabled = false;
      nameInputRef.cdRef.detectChanges();
      if(planRef.data.length > 0){
        if(planRef.data[0] == planRef.options[0].value){
          specialtyRef1.hide = false;
          specialtyRef1.disabled = false;
          specialtyRef2.hide = true;
          specialtyRef3.hide = true;
          specialtyRef4.hide = true;
          if(specialtyRef2.selected.length > 0){
            specialtyRef2.clearComponent();
          }
          if(specialtyRef3.selected.length > 0){
            specialtyRef3.clearComponent();
          }
          if(specialtyRef4.selected.length > 0){
            specialtyRef4.clearComponent();
          }
        }else if(planRef.data[0] == planRef.options[1].value){
          specialtyRef2.hide = false;
          specialtyRef2.disabled = false;
          specialtyRef1.hide = true;
          specialtyRef3.hide = true;
          specialtyRef4.hide = true;
          if(specialtyRef1.selected.length > 0){
            specialtyRef1.clearComponent();
          }
          if(specialtyRef3.selected.length > 0){
            specialtyRef3.clearComponent();
          }
          if(specialtyRef4.selected.length > 0){
            specialtyRef4.clearComponent();
          }
        }else if(planRef.data[0] == planRef.options[2].value){
          specialtyRef3.hide = false;
          specialtyRef3.disabled = false;
          specialtyRef1.hide = true;
          specialtyRef2.hide = true;
          specialtyRef4.hide = true;
          if(specialtyRef1.selected.length > 0){
            specialtyRef1.clearComponent();
          }
          if(specialtyRef2.selected.length > 0){
            specialtyRef2.clearComponent();
          }
          if(specialtyRef4.selected.length > 0){
            specialtyRef4.clearComponent();
          }
        }else if(planRef.data[0] == planRef.options[3].value){
          specialtyRef4.hide = false;
          specialtyRef4.disabled = false;
          specialtyRef1.hide = true;
          specialtyRef2.hide = true;
          specialtyRef3.hide = true;
          if(specialtyRef1.selected.length > 0){
            specialtyRef1.clearComponent();
          }
          if(specialtyRef2.selected.length > 0){
            specialtyRef2.clearComponent();
          }
          if(specialtyRef3.selected.length > 0){
            specialtyRef3.clearComponent();
          }
        }
      } else {
        nameInputRef.disabled = true;
        nameInputRef.data = undefined;
        nameInputRef.cdRef.detectChanges();
        specialtyRef1.disabled = true;
        specialtyRef1.clearComponent();
        specialtyRef2.disabled = true;
        specialtyRef2.clearComponent();
        specialtyRef3.disabled = true;
        specialtyRef3.clearComponent();
        specialtyRef4.disabled = true;
        specialtyRef4.clearComponent();
      }

      // During the initial result-page build, the plan dropdown can emit before
      // the specialty dropdown is hydrated; do not clear the submitted specialty
      // state or cancel the pending initial search timer in that pass.
      if (this.isInitialSearh) return;

      const activeSpecialtyRef = [specialtyRef1, specialtyRef2, specialtyRef3, specialtyRef4]
        .find((ref: any) => !ref.hide && !ref.disabled);
      const specialties = Array.isArray(activeSpecialtyRef?.data)
        ? activeSpecialtyRef.data.filter((item: any) => typeof item === 'string' ? item.trim().length > 0 : !!item)
        : [];

      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          specialtiesV2: specialties,
        },
      });

      if(this.isClearingFilters) return;
      this.isSearchEnabled();
    }
  }

  // checking if all the required fields are filled
  isSearchEnabled() {
    if (this.isClearingFilters) return;

    if (this.searchTriggerTimer) {
      clearTimeout(this.searchTriggerTimer);
      this.searchTriggerTimer = null;
    }

    let isFormValid;
    if(CURRENT_TENNANT == 'villagecare' || CURRENT_TENNANT == 'riverspring' || CURRENT_TENNANT == 'elderservehealth'){
      const hasProgramType = Array.isArray(this.searchState.Query.programType) &&
                             this.searchState.Query.programType.length > 0 &&
                             this.searchState.Query.programType[0] !== '';
      const hasValidName = typeof this.searchState.Query.name !== 'undefined' &&
                           this.searchState.Query.name.trim() !== '' &&
                           this.searchState.Query.name.length >= 2;
      const hasValidSpecialties = Array.isArray(this.searchState.Query.specialtiesV2) &&
                                  this.searchState.Query.specialtiesV2.length > 0;

      isFormValid =
        typeof this.searchState.Extra.locationText !== 'undefined' &&
        hasProgramType &&
        (hasValidName || hasValidSpecialties);
    }else if(CURRENT_TENNANT == 'champion'){
      isFormValid =
        typeof this.searchState.Extra.locationText !== 'undefined' &&
        this.searchState.Query.planState &&
        (
          (typeof this.searchState.Query.name !== 'undefined' &&
            this.searchState.Query.name.trim() !== '' && this.searchState.Query.name.length >= 2) ||
          (Array.isArray(this.searchState.Query.specialtiesV2) &&
            this.searchState.Query.specialtiesV2.length > 0)
        );
    }else{
      isFormValid =
        typeof this.searchState.Extra.locationText !== 'undefined' &&
        (
          (typeof this.searchState.Query.name !== 'undefined' &&
            this.searchState.Query.name.trim() !== '' && this.searchState.Query.name.length >= 2) ||
          (Array.isArray(this.searchState.Query.specialtiesV2) &&
            this.searchState.Query.specialtiesV2.length > 0)
        );
    }
    if(!isFormValid) return;

    let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
    this.overlay.destroyOverlay(cfMainUk, cfMainUk); // inorder to control the multiple loader overlay
    this.overlay.destroyOverlay(cfMainUk, cfMainUk); // inorder to control the multiple loader overlay

    this.searchTriggerTimer = setTimeout(() => {
      this.handleSearchClick();
    }, 350);
  }

  // champion tenant specific: enable/disable the "Update Search" button the same way the home page's saveButton is,
  // the button comes in as group[1] from the required search inputs' handleInputChange group
  // (only the champion template wires it up, so other tenants never reach past the ref check)
  private updateSearchButtonState(group: any): void {
    const updateSearchUk = group?.[1]?.uniqueKey;
    const updateSearchRef = updateSearchUk ? this.gmList.gmList[updateSearchUk]?.reference : undefined;
    if (!updateSearchRef) return;

    const isFormValid =
      typeof this.searchState.Extra.locationText !== 'undefined' &&
      (Array.isArray(this.searchState.Query.planState) &&
        this.searchState.Query.planState.length > 0) &&
      (
        (typeof this.searchState.Query.name !== 'undefined' &&
          this.searchState.Query.name.trim() !== '' && this.searchState.Query.name.length >= 2) ||
        (Array.isArray(this.searchState.Query.specialtiesV2) &&
          this.searchState.Query.specialtiesV2.length > 0)
      );

    updateSearchRef.disabled = !isFormValid;
    // the inner <button> only picks up the new disabled state on change detection
    // (updates such as the Google location autocomplete arrive outside Angular's zone)
    updateSearchRef.cdRef?.detectChanges?.();
  }
  updateDistanceSlider(group: any){
    let distanceDDRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let sliderRef = this.gmList.gmList[group[1].uniqueKey].reference;
    sliderRef.data = distanceDDRef.data[0];
  }

  checkedPreciseLocation(group: any){
    let preciseCheckboxRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let sliderRef = this.gmList.gmList[group[1].uniqueKey].reference;
    let distanceDropRef = this.gmList.gmList[group[2].uniqueKey].reference;
    if(preciseCheckboxRef.checked){
      this.isPreciseLocationChecked = true;
      this.searchState.Query.isPreciseLocation = true;
      sliderRef.disabled = true;
      distanceDropRef.disabled = true;
      this.isSearchEnabled();
    }else{
      this.isPreciseLocationChecked = false;
      this.searchState.Query.isPreciseLocation = undefined
      sliderRef.disabled = false;
      distanceDropRef.disabled = false;
      this.isSearchEnabled();
    }
  }

  //search-filter groups
  selectedLanguage(group: any){
    this.languageDropdownUK = group[0].uniqueKey;
    this.languagePillUK = group[1].uniqueKey;
    let languagePillRef = this.gmList.gmList[this.languagePillUK].reference;
    let languageDropdownRef = this.gmList.gmList[this.languageDropdownUK].reference;
    let languageDropdownData = languageDropdownRef.data;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, language: languageDropdownData },
    });

    let areSame = this.lobhelper.compareArrays(languagePillRef.data, languageDropdownRef.selected);
    //if (!areSame) {
      if(languageDropdownRef.selected.length != 0){
        languagePillRef.data =  languageDropdownRef.selected;
        languagePillRef.hide = false;
      }else{
        languagePillRef.hide = true;
      }
      // languagePillRef.data = languageDropdownData;
    //}
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  selectedGender(group: any){
    this.genderDropdownUK = group[0].uniqueKey;
    let genderDropdownRef = this.gmList.gmList[this.genderDropdownUK].reference;
    this.genderPillUK = group[1].uniqueKey;
    let genderPillRef = this.gmList.gmList[this.genderPillUK].reference;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, gender: genderDropdownRef.data[0] },
    });
    if(genderDropdownRef.selected.length != 0){
      genderPillRef.label = genderDropdownRef.selected[0];
      genderPillRef.hide = false;
    }else{
      genderPillRef.hide = true;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  selectedTelehealth(group: any){
    this.telehealthDropdownUK = group[0].uniqueKey;
    let telehealthDropdownRef = this.gmList.gmList[this.telehealthDropdownUK].reference;
    this.telehealthPillUK = group[1].uniqueKey;
    let telehealthPillRef = this.gmList.gmList[this.telehealthPillUK].reference;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, telehealthFilter: telehealthDropdownRef.data[0] },
    });
    if(telehealthDropdownRef.selected.length != 0){
      telehealthPillRef.label = telehealthDropdownRef.selected[0];
      telehealthPillRef.hide = false;
    }else{
      telehealthPillRef.hide = true;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  acceptingDropdownUpdate(group: any) {
    this.acceptingDropdownUK = group[0].uniqueKey;
    let acceptingDropdownRef = this.gmList.gmList[this.acceptingDropdownUK].reference;
    this.acceptingPillUK = group[1].uniqueKey;
    let acceptingPillRef = this.gmList.gmList[this.acceptingPillUK].reference;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, acceptingPatientsCodes: acceptingDropdownRef.data },
    });
    if (acceptingDropdownRef.selected.length != 0){
      acceptingPillRef.label = acceptingDropdownRef.selected[0];
      acceptingPillRef.hide = false;
    }
    else {
      acceptingPillRef.hide = true;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  private handleCheckboxChange(
    group: any[],
    queryKey: string,
    checkboxKeyProp: string,
    pillKeyProp: string
  ): void {
    const checkboxUK = group[0].uniqueKey;
    const pillUK = group[1].uniqueKey;

    (this as any)[checkboxKeyProp] = checkboxUK;
    (this as any)[pillKeyProp] = pillUK;

    const checkboxRef = this.gmList.gmList[checkboxUK].reference;
    const pillRef = this.gmList.gmList[pillUK].reference;

    const isChecked = checkboxRef.checked ? true : undefined;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, [queryKey]: isChecked },
    });

    if (checkboxRef.checked) {
      pillRef.label = checkboxRef.label;
      pillRef.hide = false;
    } else {
      pillRef.hide = true;
    }

    if (this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  checkedAccepting(group: any) {
    this.handleCheckboxChange(group, 'isAcceptingNewPatient', 'anpCheckboxUK', 'anpPillUk');
  }

  checkedHandicap(group: any) {
    this.handleCheckboxChange(group, 'isHandicapAccessible', 'handicapCheckboxUK', 'handicapPillUK');
  }

  checkedPCP(group: any) {
    const checkboxUK = group[0].uniqueKey;
    const pillUK = group[1].uniqueKey;
    this.pcpCheckboxUK = checkboxUK;
    this.pcpPillUk = pillUK;

    const checkboxRef = this.gmList.gmList[checkboxUK].reference;
    const pillRef = this.gmList.gmList[pillUK].reference;
    const isChecked = checkboxRef.checked ? true : undefined;
    if (CURRENT_TENNANT === 'champion') {
      const nextSpecialties = this.applyPcpSpecialtySelection(!!isChecked);
      this.searchStateService.updateSearchCriteria({
        Query: { ...this.searchState.Query, isPCP: isChecked, specialtiesV2: nextSpecialties },
      });
    } else {
      this.searchStateService.updateSearchCriteria({
        Query: { ...this.searchState.Query, isPCP: isChecked },
      });
    }

    if (checkboxRef.checked) {
      pillRef.label = checkboxRef.label;
      pillRef.hide = false;
    } else {
      pillRef.hide = true;
    }

    if (this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  checkedSpecialist(group: any) {
    this.handleCheckboxChange(group, 'isSCP', 'specialistCheckboxUK', 'specialistPillUK');
  }

  checkedHomevisits(group: any) {
    this.handleCheckboxChange(group, 'isMakeHomeVisits', 'homeVisitsCheckboxUK', 'homeVisitsPillUK');
  }

  checkedAdacomp(group: any) {
    this.handleCheckboxChange(group, 'isADACompliantOffice', 'adacompCheckboxUK', 'adacompPillUK');
  }
  checkedTelehealth(group: any) {
    this.handleCheckboxChange(group, 'isTelehealthServices', 'telehealthCheckboxUK', 'telehealthCheckboxPillUK');
  }

  //close language pill groups and reset the language dropdown
  resetFilterLanguage(group: any){
    let languageDropdownRef = this.gmList.gmList[this.languageDropdownUK].reference;
    let pillsGroupsRef = this.gmList.gmList[this.languagePillUK].reference;
    let languagePillGroupData = pillsGroupsRef.data;
    let langPillValues = this.getLanguageValuesFromDescriptions(languageDropdownRef.options, pillsGroupsRef.data);
    let areSame = this.lobhelper.compareArrays(languageDropdownRef.selected, languagePillGroupData);

    if(langPillValues.length == 0){
      this.searchState.Query.language = undefined;
      pillsGroupsRef.hide = true;
    }
    if (!areSame) {
      languageDropdownRef.data = langPillValues;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }
  getLanguageValuesFromDescriptions(options: option[], selectedDescriptions: string[]) {
    return options
      .filter(option => selectedDescriptions.includes(option.description))
      .map(option => option.value);
  }

  //close gender pill and reset the gender dropdown
  resetFilterGender(group: any){
    if ("gender" in this.searchState.Query) {
      this.searchState.Query.gender = undefined;
    }
    let genderDropdownRef = this.gmList.gmList[this.genderDropdownUK].reference;
    genderDropdownRef.data = [];
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  //close gender pill and reset the gender dropdown
  resetFilterTelehealth(group: any){
    // if ("gender" in this.searchState.Query) {
    //   this.searchState.Query.gender = undefined;
    // }
    let telehealthDropdownRef = this.gmList.gmList[this.telehealthDropdownUK].reference;
    telehealthDropdownRef.data = [];
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  //close ANP pill and reset the ANP checkbox
  resetANPCheckbox(group: any){
    this.searchState.Query.isAcceptingNewPatient = undefined;
    let handicapCheckboxRef = this.gmList.gmList[this.anpCheckboxUK].reference;
    handicapCheckboxRef.checked = false;
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }
  resetFilterAccepting(group: any){
    if ("acceptingPatientsCodes" in this.searchState.Query) {
      this.searchState.Query.acceptingPatientsCodes = undefined;
    }
    let acceptingDropdownRef = this.gmList.gmList[this.acceptingDropdownUK].reference;
    acceptingDropdownRef.data = [];
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  //close Handicap pill and reset the Handicap checkbox
  resetHandicapCheckbox(group: any){
    this.searchState.Query.isHandicapAccessible = undefined;
    let anpCheckboxRef = this.gmList.gmList[this.handicapCheckboxUK].reference;
    anpCheckboxRef.checked = false;
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  //close PCP pill and reset the PCP checkbox
  resetPCPCheckbox(group: any){
    this.searchState.Query.isPCP = undefined;
    const nextSpecialties = CURRENT_TENNANT === 'champion'
      ? this.applyPcpSpecialtySelection(false)
      : this.searchState.Query.specialtiesV2;

    // Ensure we have the checkbox UK even when arriving from Search page with preselected PCP
    let checkboxUK = this.pcpCheckboxUK;
    if (!checkboxUK) {
      const cfLeftUK = this.lobhelper.getDesiredChildUK("1", "cf_left");
      const sidebarUK = this.lobhelper.getDesiredChildUK(cfLeftUK, "cf_sidebar");
      const filtersContainerUK = this.lobhelper.getDesiredChildUK(sidebarUK, "filters");
      checkboxUK = this.lobhelper.getDesiredChildUK(filtersContainerUK, "filters_pcp");
      this.pcpCheckboxUK = checkboxUK; // cache for later interactions
    }
    if (checkboxUK) {
      const pcpCheckboxRef = this.gmList.gmList[checkboxUK].reference;
      pcpCheckboxRef.checked = false;
    }
    this.hidePcpFilterPill();
    if (CURRENT_TENNANT === 'champion') {
      this.searchStateService.updateSearchCriteria({
        Query: { ...this.searchState.Query, isPCP: undefined, specialtiesV2: nextSpecialties },
      });
    } else {
      this.searchStateService.updateSearchCriteria({
        Query: { ...this.searchState.Query, isPCP: undefined },
      });
    }

    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  //close Specialist pill and reset the Specialist checkbox
  resetSpecialistCheckbox(group: any){
    if ("isSCP" in this.searchState.Query) {
      this.searchState.Query.isSCP = undefined;
    }
    let specialistCheckboxRef = this.gmList.gmList[this.specialistCheckboxUK].reference;
    specialistCheckboxRef.checked = false;
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  //close TelehealthCheckbox pill and reset the Telehealth checkbox
  resetTelehealthCheckbox(group: any){
    // if ("isSCP" in this.searchState.Query) {
    //   this.searchState.Query.isSCP = undefined;
    // }
    let telehealthCheckboxRef = this.gmList.gmList[this.telehealthCheckboxUK].reference;
    telehealthCheckboxRef.checked = false;
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  //close HomevisitsCheckbox pill and reset the HomeVisits checkbox
  resetHomevisitsCheckbox(group: any){
    if ("isMakeHomeVisits" in this.searchState.Query) {
      this.searchState.Query.isMakeHomeVisits = undefined;
    }
    let homeVisitsCheckboxRef = this.gmList.gmList[this.homeVisitsCheckboxUK].reference;
    homeVisitsCheckboxRef.checked = false;
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  //close AdacompCheckbox pill and reset the HomeVisits checkbox
  resetAdacompCheckbox(group: any){
    if ("isADACompliantOffice" in this.searchState.Query) {
      this.searchState.Query.isADACompliantOffice = undefined;
    }
    let adacompCheckboxRef = this.gmList.gmList[this.adacompCheckboxUK].reference;
    adacompCheckboxRef.checked = false;
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  // Resolve a filter reference safely; some tenants don't render every filter container.
  private getFilterReference(containerUK: string | undefined, filterKey: string): any {
    if (!containerUK) {
      return undefined;
    }
    try {
      const filterUK = this.lobhelper.getDesiredChildUK(containerUK, filterKey);
      return filterUK ? this.gmList.gmList[filterUK]?.reference : undefined;
    } catch {
      return undefined;
    }
  }

  // Helper method to clear dropdown filter data
  private clearDropdownFilter(containerUK: string, filterKey: string): void {
    const filterRef = this.getFilterReference(containerUK, filterKey);
    if (filterRef) {
      filterRef.data = [];
    }
  }

  // Helper method to clear checkbox filter
  private clearCheckboxFilter(containerUK: string, filterKey: string): void {
    const filterRef = this.getFilterReference(containerUK, filterKey);
    if (filterRef) {
      filterRef.checked = false;
    }
  }


  //Behaviour Health filters
  selectedAgegroup(group: any){
    this.agegroupDropdownUK = group[0].uniqueKey;
    this.agegroupPillUK = group[1].uniqueKey;
    let agegroupPillRef = this.gmList.gmList[this.agegroupPillUK].reference;
    let agegroupDropdownRef = this.gmList.gmList[this.agegroupDropdownUK].reference;
    let agegroupDropdownData = agegroupDropdownRef.data;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, ageGroup: agegroupDropdownData },
    });

    let areSame = this.lobhelper.compareArrays(agegroupPillRef.data, agegroupDropdownRef.selected);
    //if (!areSame) {
    if(agegroupDropdownRef.selected.length != 0){
      agegroupPillRef.data =  agegroupDropdownRef.selected;
      agegroupPillRef.hide = false;
    }else{
      agegroupPillRef.hide = true;
    }
    // agegroupPillRef.data = agegroupDropdownData;
    //}
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  //close Agegroup pill groups and reset the language dropdown
  resetFilterAgegroup(group: any){
    let agegroupDropdownRef = this.gmList.gmList[this.agegroupDropdownUK].reference;
    let pillsGroupsRef = this.gmList.gmList[this.agegroupPillUK].reference;
    let agegroupPillGroupData = pillsGroupsRef.data;
    let langPillValues = this.getLanguageValuesFromDescriptions(agegroupDropdownRef.options, pillsGroupsRef.data);
    let areSame = this.lobhelper.compareArrays(agegroupDropdownRef.selected, agegroupPillGroupData);

    if(langPillValues.length == 0){
      this.searchState.Query.ageGroup = undefined;
      pillsGroupsRef.hide = true;
    }
    if (!areSame) {
      agegroupDropdownRef.data = langPillValues;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  selectedLoc(group: any){
    this.locDropdownUK = group[0].uniqueKey;
    this.locPillUK = group[1].uniqueKey;
    let locPillRef = this.gmList.gmList[this.locPillUK].reference;
    let locDropdownRef = this.gmList.gmList[this.locDropdownUK].reference;
    let locDropdownData = locDropdownRef.data;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, levelOfCare: locDropdownData },
    });

    let areSame = this.lobhelper.compareArrays(locPillRef.data, locDropdownRef.selected);
    //if (!areSame) {
    if(locDropdownRef.selected.length != 0){
      locPillRef.data =  locDropdownRef.selected;
      locPillRef.hide = false;
    }else{
      locPillRef.hide = true;
    }
    // locPillRef.data = locDropdownData;
    //}
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  resetFilterLoc(group: any){
    let locDropdownRef = this.gmList.gmList[this.locDropdownUK].reference;
    let pillsGroupsRef = this.gmList.gmList[this.locPillUK].reference;
    let locPillGroupData = pillsGroupsRef.data;
    let langPillValues = this.getLanguageValuesFromDescriptions(locDropdownRef.options, pillsGroupsRef.data);
    let areSame = this.lobhelper.compareArrays(locDropdownRef.selected, locPillGroupData);

    if(langPillValues.length == 0){
      this.searchState.Query.levelOfCare = undefined;
      pillsGroupsRef.hide = true;
    }
    if (!areSame) {
      locDropdownRef.data = langPillValues;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }
  selectedCrisis(group: any){
    this.crisisDropdownUK = group[0].uniqueKey;
    this.crisisPillUK = group[1].uniqueKey;
    let crisisPillRef = this.gmList.gmList[this.crisisPillUK].reference;
    let crisisDropdownRef = this.gmList.gmList[this.crisisDropdownUK].reference;
    let crisisDropdownData = crisisDropdownRef.data;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, crisisServices: crisisDropdownData },
    });

    let areSame = this.lobhelper.compareArrays(crisisPillRef.data, crisisDropdownRef.selected);
    //if (!areSame) {
    if(crisisDropdownRef.selected.length != 0){
      crisisPillRef.data =  crisisDropdownRef.selected;
      crisisPillRef.hide = false;
    }else{
      crisisPillRef.hide = true;
    }
    // crisisPillRef.data = crisisDropdownData;
    //}
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  resetFilterCrisis(group: any){
    let crisisDropdownRef = this.gmList.gmList[this.crisisDropdownUK].reference;
    let pillsGroupsRef = this.gmList.gmList[this.crisisPillUK].reference;
    let crisisPillGroupData = pillsGroupsRef.data;
    let langPillValues = this.getLanguageValuesFromDescriptions(crisisDropdownRef.options, pillsGroupsRef.data);
    let areSame = this.lobhelper.compareArrays(crisisDropdownRef.selected, crisisPillGroupData);

    if(langPillValues.length == 0){
      this.searchState.Query.crisisServices = undefined;
      pillsGroupsRef.hide = true;
    }
    if (!areSame) {
      crisisDropdownRef.data = langPillValues;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }
  selectedAffiliation(group: any){
    this.affiliationDropdownUK = group[0].uniqueKey;
    this.affiliationPillUK = group[1].uniqueKey;
    let affiliationPillRef = this.gmList.gmList[this.affiliationPillUK].reference;
    let affiliationDropdownRef = this.gmList.gmList[this.affiliationDropdownUK].reference;
    let affiliationDropdownData = affiliationDropdownRef.data;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, affiliation: affiliationDropdownData },
    });

    let areSame = this.lobhelper.compareArrays(affiliationPillRef.data, affiliationDropdownRef.selected);
    //if (!areSame) {
    if(affiliationDropdownRef.selected.length != 0){
      affiliationPillRef.data =  affiliationDropdownRef.selected;
      affiliationPillRef.hide = false;
    }else{
      affiliationPillRef.hide = true;
    }
    // affiliationPillRef.data = affiliationDropdownData;
    //}
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  resetFilterAffiliation(group: any){
    let affiliationDropdownRef = this.gmList.gmList[this.affiliationDropdownUK].reference;
    let pillsGroupsRef = this.gmList.gmList[this.affiliationPillUK].reference;
    let affiliationPillGroupData = pillsGroupsRef.data;
    let langPillValues = this.getLanguageValuesFromDescriptions(affiliationDropdownRef.options, pillsGroupsRef.data);
    let areSame = this.lobhelper.compareArrays(affiliationDropdownRef.selected, affiliationPillGroupData);

    if(langPillValues.length == 0){
      this.searchState.Query.affiliation = undefined;
      pillsGroupsRef.hide = true;
    }
    if (!areSame) {
      affiliationDropdownRef.data = langPillValues;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }

  selectedConditions(group: any){
    this.conditionsDropdownUK = group[0].uniqueKey;
    this.conditionsPillUK = group[1].uniqueKey;
    let conditionsPillRef = this.gmList.gmList[this.conditionsPillUK].reference;
    let conditionsDropdownRef = this.gmList.gmList[this.conditionsDropdownUK].reference;
    let conditionsDropdownData = conditionsDropdownRef.data;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, conditionsTreated: conditionsDropdownData },
    });

    let areSame = this.lobhelper.compareArrays(conditionsPillRef.data, conditionsDropdownRef.selected);
    //if (!areSame) {
    if(conditionsDropdownRef.selected.length != 0){
      conditionsPillRef.data =  conditionsDropdownRef.selected;
      conditionsPillRef.hide = false;
    }else{
      conditionsPillRef.hide = true;
    }
    // conditionsPillRef.data = conditionsDropdownData;
    //}
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

//close Conditions pill groups and reset the language dropdown
  resetFilterConditions(group: any){
    let conditionsDropdownRef = this.gmList.gmList[this.conditionsDropdownUK].reference;
    let pillsGroupsRef = this.gmList.gmList[this.conditionsPillUK].reference;
    let conditionsPillGroupData = pillsGroupsRef.data;
    let langPillValues = this.getLanguageValuesFromDescriptions(conditionsDropdownRef.options, pillsGroupsRef.data);
    let areSame = this.lobhelper.compareArrays(conditionsDropdownRef.selected, conditionsPillGroupData);

    if(langPillValues.length == 0){
      this.searchState.Query.conditionsTreated = undefined;
      pillsGroupsRef.hide = true;
    }
    if (!areSame) {
      conditionsDropdownRef.data = langPillValues;
    }
    if(this.isClearingFilters) return;
    this.isSearchEnabled();
  }




  // clear filter entires and pills
  clearFilters(group: any){
    this.isClearingFilters = true;
    // In Clear Filters, the emitted group targets multiple disparate components, not a single container.
    // So derive the left sidebar filters container explicitly and reset items from there.
    const cfLeftUK = this.lobhelper.getDesiredChildUK("1", "cf_left");
    const sidebarUK = this.lobhelper.getDesiredChildUK(cfLeftUK, "cf_sidebar");
    const filtersContainerUK = this.lobhelper.getDesiredChildUK(sidebarUK, "filters");
    const bhFiltersContainerUK = this.lobhelper.getDesiredChildUK(sidebarUK, "bh_filters");

    // Clear dropdown filters (language, gender, telehealth dropdown)
    const dropdownFilters = ['filters_language', 'filters_gender', 'filters_telehealth'];
    dropdownFilters.forEach(filter => this.clearDropdownFilter(filtersContainerUK, filter));

    // Clear dropdown filters (language, gender, telehealth dropdown)
    const dropdownFilters2 = ['filters_agegroup', 'filters_loc', 'filters_crisis', 'filters_affiliation', 'filters_conditions'];
    dropdownFilters2.forEach(bh_filters => this.clearDropdownFilter(bhFiltersContainerUK, bh_filters));

    // Clear checkbox filters using the concrete keys available in the left filters
    const checkboxFilters = [
      'filters_anp',
      'filters_ha',
      'filters_pcp',
      'filters_specialist',
      'filters_telehealth_check',
      'filters_homevisits',
      'filters_adacomp'
    ];
    checkboxFilters.forEach(filter => this.clearCheckboxFilter(filtersContainerUK, filter));
    this.hidePcpFilterPill();

    // Clear search state query properties
    this.searchState.Query.language = undefined;
    if ("gender" in this.searchState.Query) {
      this.searchState.Query.gender = undefined;
    }
    this.searchState.Query.isAcceptingNewPatient = undefined;
    this.searchState.Query.isHandicapAccessible = undefined;
    if ("isPCP" in this.searchState.Query) {
      this.searchState.Query.isPCP = undefined;
    }
    if (CURRENT_TENNANT === 'champion') {
      this.searchState.Query.specialtiesV2 = this.applyPcpSpecialtySelection(false);
    }
    if ("isSCP" in this.searchState.Query) {
      this.searchState.Query.isSCP = undefined;
    }
    if ("isADACompliantOffice" in this.searchState.Query) {
      this.searchState.Query.isADACompliantOffice = undefined;
    }
    if ("isMakeHomeVisits" in this.searchState.Query) {
      this.searchState.Query.isMakeHomeVisits = undefined;
    }
    if ("isTelehealthServices" in this.searchState.Query) {
      this.searchState.Query.isTelehealthServices = undefined;
    }
    this.searchState.Query.acceptingPatientsCodes = undefined;
    if ("telehealthFilter" in this.searchState.Query) {
      // Clear telehealth dropdown selected value in state as well
      (this.searchState.Query as any).telehealthFilter = undefined;
    }
    this.searchState.Query.ageGroup = undefined;
    this.searchState.Query.levelOfCare = undefined;
    this.searchState.Query.affiliation = undefined;
    this.searchState.Query.crisisServices = undefined;
    this.searchState.Query.conditionsTreated = undefined;

    setTimeout(() => {
      this.isClearingFilters = false;
      this.isSearchEnabled();
      this.updateClearFiltersButtonVisibility();
    }, 100);
  }
  updateClearFiltersButtonVisibility() {
    const cfRightUK = this.lobhelper.getDesiredChildUK("1", "cf_right");
    const cfFiltersUK = this.lobhelper.getDesiredChildUK(cfRightUK, "cf_filters");
    const cfFilterRef = this.gmList?.gmList?.[cfFiltersUK].reference;

    // Only check filters you care about
    const query = this.searchState?.Query || {};

    const hasLanguage = Array.isArray(query.language) && query.language.length > 0;
    const hasGender = 'gender' in query && !!query.gender;
    const hasANP = !!query.isAcceptingNewPatient;
    const hasHA = !!query.isHandicapAccessible;
    const hasPCP = 'isPCP' in query && !!query.isPCP;
    const hasSpecialist = 'isSCP' in query && !!query.isSCP;
    const hasAcceptingDD = Array.isArray(query.acceptingPatientsCodes) && query.acceptingPatientsCodes.length > 0;
    const hasTelehealthDD = "telehealthFilter" in query && !!query.telehealthFilter;
    const hasTelehealthChecbox = "isTelehealthServices" in query && !!query.isTelehealthServices;
    const hasADACompliantOffice = "isADACompliantOffice" in query && !!query.isADACompliantOffice;
    const hasMakeHomeVisits = "isMakeHomeVisits" in query && !!query.isMakeHomeVisits;
    const hasAgegroup = Array.isArray(query.ageGroup) && query.ageGroup.length > 0;
    const hasLoc = Array.isArray(query.levelOfCare) && query.levelOfCare.length > 0;
    const affiliation = Array.isArray(query.affiliation) && query.affiliation.length > 0;
    const crisisServices = Array.isArray(query.crisisServices) && query.crisisServices.length > 0;
    const conditionsTreated = Array.isArray(query.conditionsTreated) && query.conditionsTreated.length > 0;

    const shouldShowClearButton = hasLanguage || hasGender || hasANP || hasHA || hasPCP || hasAcceptingDD || hasSpecialist
      || hasTelehealthDD || hasADACompliantOffice || hasMakeHomeVisits || hasTelehealthChecbox || hasAgegroup || hasLoc || affiliation || crisisServices || conditionsTreated;

    // Only show if one of these filters is active
    cfFilterRef.hide = !shouldShowClearButton;
    if(shouldShowClearButton){
      this.gmList.gmList[1].reference.elemRef.nativeElement.classList.add('filters-visible');
    }else{
      this.gmList.gmList[1].reference.elemRef.nativeElement.classList.remove('filters-visible');
    }
  }

  private applyPcpSpecialtySelection(isChecked: boolean): string[] {
    const specialtyDropdownRef = this.getActiveSpecialtyDropdownRefForPcp();
    const nextValues = applyPcpSpecialtySelectionToDropdown({
      isChecked,
      dropdownRef: specialtyDropdownRef,
      currentValues: Array.isArray(this.searchState.Query.specialtiesV2)
        ? this.searchState.Query.specialtiesV2
        : [],
    });
    this.searchState.Query.specialtiesV2 = nextValues;
    return nextValues;
  }

  private getActiveSpecialtyDropdownRefForPcp(): any {
    const refs = this.getSpecialtyDropdownRefsByJsonId([
      'provider_or_speciality_dropdown',
      'provider_or_speciality_dropdown2',
      'provider_or_speciality_dropdown3',
      'provider_or_speciality_dropdown4',
      'providerOrSpecialityDropdown',
      'providerOrSpecialityDropdown2',
      'providerOrSpecialityDropdown3',
      'providerOrSpecialityDropdown4',
    ]);
    return getActiveVisibleEnabledRef(refs);
  }

  private getSpecialtyDropdownRefsByJsonId(dropdownIds: string[]): any[] {
    return getRefsByJsonId(this.gmList.gmList as any, dropdownIds);
  }

  private hidePcpFilterPill(): void {
    let pcpPillRef = this.pcpPillUk ? this.gmList.gmList[this.pcpPillUk]?.reference : undefined;
    if (!pcpPillRef) {
      pcpPillRef = this.getSpecialtyDropdownRefsByJsonId(['filter_pcp'])[0];
    }
    hideFilterPill(pcpPillRef);
  }


  /* print code */
  // Simple user-agent check for mobile devices
  isMobile(): boolean {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
  printReady(): boolean {
    if(this.currentTab === 'tab_provider') {
      return this.printProviderReady;
    }
    return this.printFacilityReady;
  }
  printResults(group: any) {
    // if(!this.printReady()) return;
    // //TODO: To be revised after configuration driven UI is implemented
    // if (CURRENT_TENNANT == 'mddoh'){
    //   document.title = "Maryland Medicaid Provider Finder";
    // }
    // window.print();
    if(this.currentTab === 'tab_provider') {
      if(this.totalProviderResults > 0) {
        this.printProviderResults();
      }
    } else if (this.currentTab === 'tab_facility') {
      if(this.totalFacilityResults > 0) {
        this.printFacilityResults();
      }
    }
  }

  async printProviderResults() {
    let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
    await this.overlay.createOverlay(cfMainUk, true, cfMainUk);

    // Build ProviderSearchRequest for printing with route and location.text
    const baseQuery: BasicProviderSearchQuery = {
      ...omitBy(this.printState.Query as any, isNull),
    } as BasicProviderSearchQuery;

    const currentRoute = (typeof window !== 'undefined' && window.location && window.location.href)
      ? window.location.href
      : this.router.url;

    const locationText = this.printState?.Extra?.locationText;
    const finalLocation = locationText
      ? { ...(baseQuery.location || {}), text: locationText }
      : baseQuery.location;

    const finalQuery: BasicProviderSearchQuery = {
      ...baseQuery,
      route: currentRoute,
      ...(finalLocation ? { location: finalLocation } : {}),
      skip: 0,
      limit: 500,
    };

    this.printAllResultsData = {
      queryType: 'mtProviderSearchV2',
      query: finalQuery,
    } as ProviderSearchRequest;

    this.printService.getPrintPdfForAllProvider(this.printAllResultsData).subscribe({
      next: (pdfBlob) => {
        const blobUrl = URL.createObjectURL(pdfBlob);
        if (this.isMobile()) {
          // Mobile: open PDF directly (avoids cross-origin iframe access)
          window.open(blobUrl, '_blank');
          // Clean up immediately
          this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          return;
        }

        // Desktop: keep existing iframe-based print logic
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        document.body.appendChild(iframe);
        iframe.onload = () => {
          try {
            iframe.contentWindow?.print();
          } finally {
            // Revoke URL and remove overlay regardless of print outcome
            URL.revokeObjectURL(blobUrl);
            this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          }
        };
      },
      error: (err) => {
        console.error('Error generating provider results PDF:', err);
        // Ensure overlay is removed on error as well
        this.overlay.destroyOverlay(cfMainUk, cfMainUk);
      }
    });
  }

  async printFacilityResults() {
    let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
    await this.overlay.createOverlay(cfMainUk, true, cfMainUk);

    // Build FacilitySearchRequest for printing with route and location.text
    const baseQuery: BasicOrganizationSearchQuery = {
      ...omitBy(this.printState.Query as any, isNull),
    } as BasicOrganizationSearchQuery;

    const currentRoute = (typeof window !== 'undefined' && window.location && window.location.href)
      ? window.location.href
      : this.router.url;

    const locationText = this.printState?.Extra?.locationText;
    const finalLocation = locationText
      ? { ...(baseQuery.location || {}), text: locationText }
      : baseQuery.location;

    const finalQuery:BasicOrganizationSearchQuery  = {
      ...baseQuery,
      route: currentRoute,
      ...(finalLocation ? { location: finalLocation } : {}),
      skip: 0,
      limit: 500,
    };

    const facilityRequest: FacilitySearchRequest = {
      queryType: 'mtOrganizationSearchV2',
      query: finalQuery,
    };

    this.printAllResultsData = facilityRequest;

    this.printService.getPrintPdfForAllFacility(facilityRequest).subscribe({
      next: (pdfBlob) => {
        const blobUrl = URL.createObjectURL(pdfBlob);
        if (this.isMobile()) {
          window.open(blobUrl, '_blank');
          this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          return;
        }

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        document.body.appendChild(iframe);
        iframe.onload = () => {
          try {
            iframe.contentWindow?.print();
          } finally {
            // Revoke URL and remove overlay regardless of print outcome
            URL.revokeObjectURL(blobUrl);
            this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          }
        };
      },
      error: (err) => {
        console.error('Error generating provider results PDF:', err);
        // Ensure overlay is removed on error as well
        this.overlay.destroyOverlay(cfMainUk, cfMainUk);
      }
    });
  }
  buildPreface() {
    let folderPath = '../../assets/preface-' + CURRENT_TENNANT + '/'

    if(CURRENT_TENNANT === 'riverspring') [
      this.imgPaths = [
        folderPath + 'page1.png',
        folderPath + 'page2.png',
        folderPath + 'page3.png',
        folderPath + 'page4.png',
        folderPath + 'page5.png'
      ]
    ]
  }


  // handleSearchClick
  async handleSearchClick() {
    if (this.activeSearchSubscription) {
      this.activeSearchSubscription.unsubscribe();
      this.activeSearchSubscription = undefined;
    }

    let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
    const promise = await this.overlay.createOverlay(cfMainUk, true, cfMainUk);
    if (promise) {
      this.printProviderReady = false
      this.printFacilityReady = false
      this.printState = this.searchState;
      this.facilityPrintResults = {}
      this.providerPrintResults = {}
      this.currentPageProvider = 1;
      this.currentPageFacility = 1;
      const providerQueryParams: BasicProviderSearchQueryV2 = {
        ...omitBy(this.searchStateService.getSearchCriteria().Query, isNull),
        skip: 0,
        limit: this.itemsPerPageProvider,
      };

      const facilityQueryParams: BasicOrganizationSearchQueryV2 = {
        ...omitBy(this.searchStateService.getSearchCriteria().Query, isNull),
        skip: 0,
        limit: this.itemsPerPageFacility,
      };

      this.activeSearchSubscription = forkJoin({
        providerResults:
          this.searchV2Service.getProviderResults(providerQueryParams),
        facilityResults:
          this.searchV2Service.getFacilityResults(facilityQueryParams),
      }).subscribe({
        next: (results) => {
          if (results && results.providerResults && results.facilityResults) {
            this.totalProviderResults = results.providerResults.total;
            this.totalFacilityResults = results.facilityResults.total;
            this.providerFilterSearchResults = results.providerResults;
            this.facilityFilterSearchResults = results.facilityResults;
          } else {
            this.providerFilterSearchResults = {};
            this.facilityFilterSearchResults = {};
          }
          if(this.providerFilterSearchResults?.total! == 0 && this.facilityFilterSearchResults?.total! > 0){
            this.currentTab = 'tab_facility';
          } else{
            this.currentTab = 'tab_provider';
          }
          if (this.providerFilterSearchResults?.providers) {
            this.providerCardDataArray = {
              providers: this.mapSearchResults<AggregateRootOfPractitionerPractitionerRoleV2>(
                this.providerFilterSearchResults.providers,
                (item) => this.searchCardAdapter.adaptProvider(item)
              )
            };
          }
          console.log('providerCardDataArray', this.providerCardDataArray);
          if (this.facilityFilterSearchResults?.facilities) {
            this.facilityCardDataArray = {
              facilities: this.mapSearchResults<AggregateRootOfFacilityOrganizationAffiliationV2>(
                this.facilityFilterSearchResults.facilities,
                (item) => this.searchCardAdapter.adaptFacility(item)
              )
            };
          }
          console.log('facilityCardDataArray', this.facilityCardDataArray);
          this.printProviderReady = true;
          this.printFacilityReady = true;
          setTimeout(() => {
            this.showHidePrintButton();
          }, 1000);
          let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
          let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
          this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          this.updateResultTab();
        },
        error: (err) => {
          console.log('An error occurred:', err);
          this.overlay.destroyOverlay(cfMainUk, cfMainUk);
        },
        complete: () => {
          this.activeSearchSubscription = undefined;
        }
      });
    }
  }

  async updateResultTab(){
    let cfRightUK = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUK = this.lobhelper.getDesiredChildUK(cfRightUK, "cf_main");
    this.overlay.createOverlay(cfMainUK, true, cfMainUK);
    let cfMainRef = this.gmList.gmList[cfMainUK].reference;
    let resultsTabsUK = this.lobhelper.getDesiredChildUK(cfMainUK, "results_tabs");
    let isPreciseLocationChecked = this.isPreciseLocationChecked;
    // let url = "../../assets/hbs_partials/results-tabs-partial.hbs"
	if(resultsTabsUK !== undefined){
      let resultsTabsRef = this.gmList.gmList[resultsTabsUK].reference;
      await resultsTabsRef.clearForDestroy();

      const { isTeleHealthValue } = this.getTelehealthFilterStatus();
      const pageName = this.getDynamicPageName('results-tabs');

     // this.searchResultData = this.searchResultService.getSearchResultJson("../../assets/hbs_partials/villagecare-results-tabs-partial.hbs").subscribe(response => {

      this.searchResultData = this.tenantConfigServiceV2.getTenantBluePrint({page_name: pageName , tenant: CURRENT_TENNANT,'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en'})
        .subscribe((response) => {
        if(response == null) return;
        let res = decodeURIComponent(Array.prototype.map.call(atob(response), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
        const template = Handlebars.compile(res);
        const selectedPlan = this.searchStateService.getSearchCriteria().Query.programType?.[0];
        const renderedHtml = template({
          searchCriteria: this.searchStateService.getSearchCriteria(),
          locationText: this.searchStateService.getSearchCriteria().Extra.locationText,
          providerSearchResults: this.providerCardDataArray,
          totalProviderSearchResults: this.providerFilterSearchResults?.total,
          facilitySearchResults: this.facilityCardDataArray,
          totalFacilitySearchResults: this.facilityFilterSearchResults?.total,
          isIPASectionEnabled: this.isIPASectionEnabled,
          isTeleHealthValue: isTeleHealthValue,
          isPreciseLocation: isPreciseLocationChecked,
          aboutDirectoryLink: this.getPlanLink(selectedPlan),
        });
        // Wrap with curly braces to make it valid JSON
        const wrappedJson = `{${renderedHtml}}`;
        // console.log(renderedHtml);
        // console.log(wrappedJson);
        let data = JSON.parse(wrappedJson);
        cfMainRef.addChildrenToThisView(data);
        this.checkLoTabPresence();
      });
    }
    else{
      this.overlay.destroyOverlay(cfMainUK, cfMainUK);
    }
  }

  getPlanLink(value?: string | null | undefined): string | null {
    if (!value) {
      return null; // handles null, undefined, empty string
    }

    const mappedLinks = {
      'villagecaremax-managed-long-term-care-mltc': 'https://www.villagecaremax.org/mltc/members#provider_network',
      'villagecaremax-medicare-total-advantage-plan-map': 'https://www.villagecaremax.org/map/provider-network',
      'villagecaremax-medicare-health-advantage-plan-dsnp': 'https://www.villagecaremax.org/dsnp/provider-network',
      'villagecaremax-medicare-select-advantage-plan-hmo': 'https://www.villagecaremax.org/mapd/provider-network',
    } as const;

    type PlanKey = keyof typeof mappedLinks;

    if (value in mappedLinks) {
      return mappedLinks[value as PlanKey];
    }

    return null;
  }

  checkLoTabPresence(): void {
    // Get the child UK elements
    let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");

    // Check if 'results_tabs' is present
    if (this.lobhelper.getDesiredChildUK(cfMainUk, "results_tabs") && this.gmList.gmList[this.lobhelper.getDesiredChildUK(cfMainUk, "results_tabs")].reference.children.length) {
      // Condition when total results are 0 and total facilities > 0
      if (this.providerFilterSearchResults?.total! == 0 && this.facilityFilterSearchResults?.total! > 0) {
        this.currentTab = 'tab_facility';

        // Wait for 5 seconds before performing the action
        // setTimeout(() => {
          this.overlay.destroyOverlay(cfMainUk, cfMainUk);

          // Get the result tabs and change the tab to facility
          let resultTabsUk = this.lobhelper.getDesiredChildUK(cfMainUk, "results_tabs");
          this.facilityTabUk = this.lobhelper.getDesiredChildUK(resultTabsUk, "tab_facility");

          this.gmList.gmList[resultTabsUk].reference.changeTab(this.facilityTabUk, true);
        // }, 700);

      } else {
        // Condition when the result is for Individual Providers
        this.currentTab = 'tab_provider';

        // Wait for 5 seconds before performing the action
        // setTimeout(() => {
          this.overlay.destroyOverlay(cfMainUk, cfMainUk);

          // Get the result tabs and change the tab to provider
          let resultTabsUk = this.lobhelper.getDesiredChildUK(cfMainUk, "results_tabs");
          this.providerTabUk = this.lobhelper.getDesiredChildUK(resultTabsUk, "tab_provider");

          this.gmList.gmList[resultTabsUk].reference.changeTab(this.providerTabUk, true);
        // }, 700);
      }
      return; // Stop further recursion once the element is found and action is performed
    }
    setTimeout(() => this.checkLoTabPresence(), 1000); // Recursive call with a delay of 1 second
  }

  // Formating the value of the card data
  private formatValue(key: string, value: any): string {
    if (value !== "") {
      if (key === 'Phone' || key === 'Fax') {
        const regex = /\(?(\d{3})?\)?[-.\s]?(\d{3})?[-.\s]?(\d{4})?/;
        const match = value.match(regex);
        if (match) {
          return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
      }
    }
    return value;
  }
  getCardDataArray(cardData: any): { key: string; value: any }[] {
    if (!cardData?.list) {
      return [];
    }

    return Object.entries(cardData?.list).map(([key, value]) => ({
      key,
      value: this.formatValue(key, value) || undefined,
    }));
  }
  capitalizeEachWord(text: string): string {
    if (!text) return '';
    return text.toLowerCase().split(/([ -])/)
      .map(word => /^[ -]$/.test(word) ? word : word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }
  truncateDistance(dist: string | undefined): string {
    const distance = parseFloat(dist!);
    if (!isNaN(distance)) {
      return distance.toFixed(2);
    }
    return '0.00';
  }


  // to Show or hide the print results button on each provider and facility tabs
  showHidePrintButton(){
    let resultRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let resultMainUk = this.lobhelper.getDesiredChildUK(resultRightUk, "cf_main");
    let careFindrLangResizeContainerUk = this.lobhelper.getDesiredChildUK(resultMainUk, "careFindrLangResizeContainer");
    this.printProviderResultBtnUk = this.lobhelper.getDesiredChildUK(careFindrLangResizeContainerUk, "print_provider_results_button");
    this.printFacilityResultBtnUk = this.lobhelper.getDesiredChildUK(careFindrLangResizeContainerUk, "print_facility_results_button");
    if((this.providerFilterSearchResults.providers!.length > 0 || this.providerFilterSearchResults.total == 0) && (this.currentTab == "tab_provider")){
      this.gmList.gmList[this.printProviderResultBtnUk].reference.hide = false;
      this.gmList.gmList[this.printFacilityResultBtnUk].reference.hide = true;
    }else if((this.facilityFilterSearchResults.facilities!.length > 0 || this.facilityFilterSearchResults.total == 0) && (this.currentTab == "tab_facility")){
      this.gmList.gmList[this.printProviderResultBtnUk].reference.hide = true;
      this.gmList.gmList[this.printFacilityResultBtnUk].reference.hide = false;
    }else{
      this.gmList.gmList[this.printProviderResultBtnUk].reference.hide = true;
      this.gmList.gmList[this.printFacilityResultBtnUk].reference.hide = true;
    }
  }

  async printDetailProvider(group: any){
    // Show overlay spinner just like the printProviderResults button behavior
    let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
    await this.overlay.createOverlay(cfMainUk, true, cfMainUk);

    const passedInfo = group?.[0]?.passedInfo;
    const hasContext = Array.isArray(passedInfo) && passedInfo.length >= 3;
    const hasProviderCardName =  Array.isArray(passedInfo) && passedInfo.length >= 4 ? passedInfo[3] : undefined;

    const cleanup = () => {
      // Remove overlay spinner
      this.overlay.destroyOverlay(cfMainUk, cfMainUk);
    };

    const handleSuccess = (pdfBlob: Blob) => {
      const blobUrl = URL.createObjectURL(pdfBlob);

      if (this.isMobile()) {
        window.open(blobUrl, '_blank');
        cleanup();
        return;
      }

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        try {
          iframe.contentWindow?.print();
        } finally {
          URL.revokeObjectURL(blobUrl);
          cleanup();
        }
      };
    };

    const handleError = (err: any) => {
      console.error('Error generating single provider PDF:', err);
      cleanup();
    };

    if (hasContext) {
      const [npiID, lat, lon] = passedInfo;
      this.searchV2Service.getProviderDetails(npiID, lat, lon).subscribe({
        next: (data: ProviderResponseOfMasteredLocationsV2 | undefined) => {
          if (!data) return handleError('No provider data');
          data.selectedPlans = this.searchStateService.getSearchCriteria()?.Query.programType ? this.searchStateService.getSearchCriteria()?.Query.programType : undefined;
          data.telehealthFilter = this.searchStateService.getSearchCriteria()?.Query.telehealthFilter ? this.searchStateService.getSearchCriteria()?.Query.telehealthFilter : undefined;
          data.providerCardName = hasProviderCardName;
          this.printService.getPrintPdfForSingleProvider(data).subscribe({
            next: handleSuccess,
            error: handleError,
          });
        },
        error: handleError,
      });
    } else {
      // Fallback to previously stored details (legacy behavior)
      this.printService.getPrintPdfForSingleProvider(this.showMoreDetailsData as ProviderResponseOfMasteredLocationsV2).subscribe({
        next: handleSuccess,
        error: handleError,
      });
    }
  }
  async printDetailFacility(group: any){
    // Show overlay spinner to match print_facility_results_button behavior
    let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
    await this.overlay.createOverlay(cfMainUk, true, cfMainUk);

    const passedInfo = group?.[0]?.passedInfo;
    const hasContext = Array.isArray(passedInfo) && passedInfo.length >= 1;
    const hasFacilityCardName =  Array.isArray(passedInfo) && passedInfo.length >= 2 ? passedInfo[1] : undefined;

    const cleanup = () => {
      // Remove overlay spinner
      this.overlay.destroyOverlay(cfMainUk, cfMainUk);
    };

    const handleSuccess = (pdfBlob: Blob) => {
      const blobUrl = URL.createObjectURL(pdfBlob);

      if (this.isMobile()) {
        window.open(blobUrl, '_blank');
        // For mobile, allow the browser to manage the blob lifecycle; ensure overlay removal
        cleanup();
        return;
      }

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        try {
          iframe.contentWindow?.print();
        } finally {
          URL.revokeObjectURL(blobUrl);
          cleanup();
        }
      };
    };

    const handleError = (err: any) => {
      console.error('Error generating single facility PDF:', err);
      cleanup();
    };

    if (hasContext) {
      const [npiID] = passedInfo;
      this.searchV2Service.getFacilityDetails(npiID).subscribe({
        next: (data: FacilityResponseOfMasteredLocationsV2 | undefined) => {
          if (!data) return handleError('No facility data');
          data.selectedPlans = this.searchStateService.getSearchCriteria()?.Query.programType ? this.searchStateService.getSearchCriteria()?.Query.programType : undefined;
          data.telehealthFilter = this.searchStateService.getSearchCriteria()?.Query.telehealthFilter ? this.searchStateService.getSearchCriteria()?.Query.telehealthFilter : undefined;
          data.facilityCardName = hasFacilityCardName;
          this.printService.getPrintPdfForSingleFacility(data).subscribe({
            next: handleSuccess,
            error: handleError,
          });
        },
        error: handleError,
      });
    } else {
      // Fallback to previously stored details (legacy behavior)
      this.printService.getPrintPdfForSingleFacility(this.showMoreDetailsData as FacilityResponseOfMasteredLocationsV2).subscribe({
        next: handleSuccess,
        error: handleError,
      });
    }
  }

  // find the first non-disabled (0/empty) tab and focus it
  focusResultsTab(group: any){
    var tabsGM = this.gmList.gmList[group[1].uniqueKey];
    // check if there's a tab that isn't disabled - this means there's at least 1 search result between provider/facility!
    var firstNotDisabledTab = tabsGM.elementRef?.querySelector(".tabs .tab:not([disabled])") as HTMLElement;
    // focus on the first not-disabled tab
    if (firstNotDisabledTab){
      firstNotDisabledTab.focus();
    }
    // if there is none, that means there were no search results, so jump to search criteria instead
    else {
      var editCriteriaButtonGM = this.gmList.gmList[group[2].uniqueKey];
      if (window.getComputedStyle(editCriteriaButtonGM.elementRef!).getPropertyValue('display') !== "none"){
        editCriteriaButtonGM.elementRef?.querySelector("button")!.click();
      }
      setTimeout(() => {
        var requiredSearchContainerGM = this.gmList.gmList[group[3].uniqueKey];
        // check first if there's a plan dropdown and if so, focus that
        var planDropdown = requiredSearchContainerGM.elementRef?.querySelector(".rs-plan") as HTMLElement;
        if (planDropdown){
          planDropdown.focus();
        }
        // no plan dropdown, so focus location instead
        else {
          var locationGAF = requiredSearchContainerGM.elementRef?.querySelector(".rs-location") as HTMLElement;
          locationGAF.focus();
        }
      });
    }
  }

  reportIssue(group: any) {
    const passedInfo = group?.[0]?.passedInfo || [];
    this.reportIssueContext = {
      stableId: passedInfo?.[0] || "",
      name: passedInfo?.[1] || "",
    };
    this.reportIssueNpi = passedInfo?.[2] || "";
    this.reportIssueLocationOptions = Array.isArray(passedInfo?.[3]) ? passedInfo[3] : [];

    const mainContainerUK = this.lobhelper.getDesiredChildUK("0", "main_outer_container");
    const reportIssueModalUK = this.lobhelper.getDesiredChildUK(mainContainerUK, "reportIssueModal");
    const thankYouModalUK = this.lobhelper.getDesiredChildUK(mainContainerUK, "thankYouModal");

    // Helper to create and show the modal
    const createAndShowModal = () => {
      let pageName = 'data-correction-reporting-form';

      // this.searchResultService.getSearchResultJson("../../assets/hbs_partials/data-correction-reporting-form.hbs").subscribe(response => {
      this.searchResultData = this.tenantConfigServiceV2.getTenantBluePrint({page_name: pageName , tenant: CURRENT_TENNANT,'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en'})
        .subscribe((response) => {
          if(response == null) return;
          let res = decodeURIComponent(Array.prototype.map.call(atob(response), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
          const template = Handlebars.compile(res);
          const defaultLocationValue = this.reportIssueLocationOptions.length === 1
            ? [this.reportIssueLocationOptions[0].value]
            : [];
          const templateData = {
            passedInfo: group[0].passedInfo,
            locationOptionsJson: JSON.stringify(this.reportIssueLocationOptions),
            defaultLocationValueJson: JSON.stringify(defaultLocationValue),
          };
          const renderedHtml = template(templateData);
          const wrappedJson = `{${renderedHtml}}`;
          const modalData = JSON.parse(wrappedJson);
          const mainContainerRef = this.gmList.gmList[mainContainerUK].reference;
          mainContainerRef.addChildrenToThisView(modalData);
        });
    };

    // Helper to clear existing modal
    const clearModal = (uniqueKey: string) => {
      if (uniqueKey && this.gmList.gmList[uniqueKey]) {
        try {
          const modalRef = this.gmList.gmList[uniqueKey].reference;
          modalRef.clearForDestroy();
        } catch (e) {
          console.warn(`Error clearing existing modal (${uniqueKey}) before recreation:`, e);
        }
      }
    };

    clearModal(reportIssueModalUK);
    clearModal(thankYouModalUK);

    // Always recreate the modal to avoid inconsistent state issues in lo-bahamut
    createAndShowModal();
  }

  handleIssueTypeChange(group: any) {
    this.validateReportIssueForm(group);
  }

  handleKnowledgeSourceChange(group: any) {
    const knowledgeSourceDropdownRef = this.gmList.gmList[group[0].uniqueKey].reference;
    const knowledgeSourceContainerUK = this.lobhelper.getDesiredParentUK(group[0].uniqueKey, "knowledge_source_container");
    const knowledgeSourceOtherUK = this.lobhelper.getDesiredChildUK(knowledgeSourceContainerUK, "knowledge_source_other");
    const knowledgeSourceOtherRef = this.gmList.gmList[knowledgeSourceOtherUK].reference;

    if (knowledgeSourceDropdownRef.data[0] === 'other') {
      knowledgeSourceOtherRef.hide = false;
    } else {
      knowledgeSourceOtherRef.hide = true;
      knowledgeSourceOtherRef.data = "";
    }
    this.validateReportIssueForm(group);
  }

  isSubmittingReportIssue = false;

  validateReportIssueForm(group: any) {
    if (this.isSubmittingReportIssue) {
      return;
    }
    const modalUK = this.lobhelper.getDesiredParentUK(group[0].uniqueKey, "reportIssueModal");
    const modalBodyUK = this.lobhelper.getDesiredChildUK(modalUK, "modal_body");

    const issueTypeContainerUK = this.lobhelper.getDesiredChildUK(modalBodyUK, "issue_type_container");
    const locationContainerUK = this.lobhelper.getDesiredChildUK(modalBodyUK, "location_container");
    const whatsIncorrectContainerUK = this.lobhelper.getDesiredChildUK(modalBodyUK, "whats_incorrect_container");
    const knowledgeSourceContainerUK = this.lobhelper.getDesiredChildUK(modalBodyUK, "knowledge_source_container");
    const userNameContainerUK = this.lobhelper.getDesiredChildUK(modalBodyUK, "user_name_container");
    const userEmailContainerUK = this.lobhelper.getDesiredChildUK(modalBodyUK, "user_email_container");

    const issueTypeDropdownUK = this.lobhelper.getDesiredChildUK(issueTypeContainerUK, "issue_type_dropdown");
    const locationDropdownUK = this.lobhelper.getDesiredChildUK(locationContainerUK, "location_dropdown");
    const whatsIncorrectUK = this.lobhelper.getDesiredChildUK(whatsIncorrectContainerUK, "whats_incorrect");
    const knowledgeSourceDropdownUK = this.lobhelper.getDesiredChildUK(knowledgeSourceContainerUK, "knowledge_source_dropdown");
    const knowledgeSourceOtherUK = this.lobhelper.getDesiredChildUK(knowledgeSourceContainerUK, "knowledge_source_other");
    const userNameUK = this.lobhelper.getDesiredChildUK(userNameContainerUK, "user_name");
    const userEmailUK = this.lobhelper.getDesiredChildUK(userEmailContainerUK, "user_email");

    const submitButtonUK = this.lobhelper.getDesiredChildUK(modalUK, "submitButton");

    const issueTypeDropdownRef = this.gmList.gmList[issueTypeDropdownUK]?.reference;
    const locationDropdownRef = this.gmList.gmList[locationDropdownUK]?.reference;
    const whatsIncorrectRef = this.gmList.gmList[whatsIncorrectUK]?.reference;
    const knowledgeSourceDropdownRef = this.gmList.gmList[knowledgeSourceDropdownUK]?.reference;
    const knowledgeSourceOtherRef = this.gmList.gmList[knowledgeSourceOtherUK]?.reference;
    const userNameRef = this.gmList.gmList[userNameUK]?.reference;
    const userEmailRef = this.gmList.gmList[userEmailUK]?.reference;
    const correctInformationUK = this.lobhelper.getDesiredChildUK(modalBodyUK, "correct_info_container");
    const correctInformationInputUK = this.lobhelper.getDesiredChildUK(correctInformationUK, "correct_information");
    const correctInformationRef = this.gmList.gmList[correctInformationInputUK]?.reference;
    const submitButtonRef = this.gmList.gmList[submitButtonUK]?.reference;

    if (!submitButtonRef) return;

    this.reportIssueFormValues = {
      issueType: issueTypeDropdownRef?.data?.[0] || "",
      issueTypeDescription:
        issueTypeDropdownRef?.options?.find((option: any) => option?.value === issueTypeDropdownRef?.data?.[0])?.description
        || issueTypeDropdownRef?.data?.[0]
        || "",
      location: locationDropdownRef?.data?.[0] || "",
      whatsIncorrect: whatsIncorrectRef?.data?.trim?.() || "",
      correctInformation: correctInformationRef?.data?.trim?.() || "",
      knowledgeSource: knowledgeSourceDropdownRef?.data?.[0] || "",
      knowledgeSourceDescription:
        knowledgeSourceDropdownRef?.options?.find((option: any) => option?.value === knowledgeSourceDropdownRef?.data?.[0])?.description
        || knowledgeSourceDropdownRef?.data?.[0]
        || "",
      knowledgeSourceOther: knowledgeSourceOtherRef?.data?.trim?.() || "",
      userName: userNameRef?.data?.trim?.() || "",
      userEmail: userEmailRef?.data?.trim?.() || "",
    };

    const isIssueTypeValid = issueTypeDropdownRef && issueTypeDropdownRef.data && issueTypeDropdownRef.data.length > 0 && issueTypeDropdownRef.data[0] !== "" && !this.validator.checkIfAnythingInvalid(issueTypeDropdownUK);
    const isLocationValid = locationDropdownRef && locationDropdownRef.data && locationDropdownRef.data.length > 0 && locationDropdownRef.data[0] !== "" && !this.validator.checkIfAnythingInvalid(locationDropdownUK);
    const isWhatsIncorrectValid = whatsIncorrectRef && whatsIncorrectRef.data && whatsIncorrectRef.data.trim() !== "" && !this.validator.checkIfAnythingInvalid(whatsIncorrectUK);
    const isKnowledgeSourceValid = true; // knowledge_source_other is optional
    const isUserNameValid = userNameRef && userNameRef.data && userNameRef.data.trim() !== "" && !this.validator.checkIfAnythingInvalid(userNameUK);
    const isUserEmailValid = userEmailRef && userEmailRef.data && userEmailRef.data.trim() !== "" && !userEmailRef.errorMessage && !this.validator.checkIfAnythingInvalid(userEmailUK);

    submitButtonRef.disabled = !(isIssueTypeValid && isLocationValid && isWhatsIncorrectValid && isKnowledgeSourceValid && isUserNameValid && isUserEmailValid);
  }

  submitReportIssue(group: any) {
    if (this.isSubmittingReportIssue) {
      return;
    }
    this.validateReportIssueForm(group);

    const mainContainerUK = this.lobhelper.getDesiredChildUK("0", "main_outer_container");
    const reportIssueModalUK = this.lobhelper.getDesiredChildUK(mainContainerUK, "reportIssueModal");
    const thankYouModalUK = this.lobhelper.getDesiredChildUK(mainContainerUK, "thankYouModal");

    const reportIssueModalRef = this.gmList.gmList[reportIssueModalUK]?.reference;
    const thankYouModalRef = this.gmList.gmList[thankYouModalUK]?.reference;

    const submitButtonUK = this.lobhelper.getDesiredChildUK(reportIssueModalUK, "submitButton");
    const submitButtonRef = this.gmList.gmList[submitButtonUK]?.reference;

    this.isSubmittingReportIssue = true;
    if (submitButtonRef) {
      submitButtonRef.disabled = true;
    }

    const issueType = this.reportIssueFormValues.issueType;
    const issueTypeDescription = this.reportIssueFormValues.issueTypeDescription;
    const selectedLocation = this.reportIssueLocationOptions.find((location) => location.value === this.reportIssueFormValues.location);
    const locationInformation = selectedLocation ? { name: selectedLocation.description, address: selectedLocation.description } : null;
    const titleSuffix = issueTypeDescription ? ` - ${issueTypeDescription}` : "";
    const issueReportedOn: "Provider" | "Facility" = this.currentTab === "tab_facility" ? "Facility" : "Provider";
    const entityDetails = {
      name: this.reportIssueContext.name,
      stableId: this.reportIssueContext.stableId,
      npi: this.reportIssueNpi || null,
      locationInformation,
    };
    const requestBody: CreateTicketRequest = {
      userName: this.reportIssueFormValues.userName,
      userEmail: this.reportIssueFormValues.userEmail,
      ticketType: issueTypeDescription,
      title: `${this.reportIssueContext.name}${titleSuffix}`,
      description: this.reportIssueFormValues.whatsIncorrect,
      ticketDetails: {
        issueReportedOn,
        providerDetails: issueReportedOn === "Provider" ? entityDetails : null,
        facilityDetails: issueReportedOn === "Facility" ? entityDetails : null,
        corrections: this.reportIssueFormValues.correctInformation,
        issueSource: {
          source: this.reportIssueFormValues.knowledgeSourceDescription || this.reportIssueFormValues.knowledgeSource,
          description: this.reportIssueFormValues.knowledgeSource === "other"
            ? this.reportIssueFormValues.knowledgeSourceOther
            : ""
        }
      }
    }
    this.ticketsService.createTicket({'x-tenant-id': CURRENT_TENNANT, body: requestBody}).subscribe({
      next: (response: any) => {
        this.isSubmittingReportIssue = false;
        if (reportIssueModalRef) {
          reportIssueModalRef.hide = true;
        }

        if (thankYouModalRef) {
          thankYouModalRef.hide = false;
        }
      },
      error: (error: any) => {
        console.error('Error submitting report issue:', error);
        this.isSubmittingReportIssue = false;
        if (submitButtonRef) {
          submitButtonRef.disabled = false;
        }
      }
    })

    // if (reportIssueModalRef) {
    //   reportIssueModalRef.hide = true;
    // }
    //
    // if (thankYouModalRef) {
    //   thankYouModalRef.hide = false;
    // }
  }

  async pagination(group: any) {
    let cfRightUk = this.lobhelper.getDesiredChildUK("1", "cf_right");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfRightUk, "cf_main");
    const promise = await  this.overlay.createOverlay(cfMainUk, true, cfMainUk);
    if (promise) {
      let parentContainerRef = this.gmList.gmList[group[0].parentToChangePage].reference;

      if (parentContainerRef.jsonid === "tab_provider_footer") {
        let tabParentUk = this.lobhelper.getDesiredParentUK(group[0].parentToChangePage, "tab_provider");
        let tabProviderCardContainerUk = this.lobhelper.getDesiredChildUK(tabParentUk, "tab_provider_results");
        let tabProviderCardContainerRef = this.gmList.gmList[tabProviderCardContainerUk].reference;
        this.itemsPerPageProvider = group[0].perPage;
        let currentPage = group[0].pageClicked;
        const skip = (currentPage - 1) * group[0].perPage;

        const queryParams = {
          ...omitBy(this.searchStateService.getSearchCriteria().Query, isNull),
          skip: skip,
          limit: group[0].perPage,
        };

        let isPreciseLocationChecked: boolean | undefined = undefined;
        if ('isPreciseLocation' in queryParams) {
          isPreciseLocationChecked = Boolean(queryParams.isPreciseLocation);
        }

        this.searchV2Service.getProviderResults(queryParams).subscribe({
          next: (results) => {
            this.providerSearchResults = results;
            if (this.providerSearchResults?.providers) {
              this.providerCardDataArray = {
                providers: this.mapSearchResults<AggregateRootOfPractitionerPractitionerRoleV2>(
                  this.providerSearchResults.providers,
                  (item) => this.searchCardAdapter.adaptProvider(item)
                )
              };

              const { isTeleHealthValue } = this.getTelehealthFilterStatus();
              const pageName = this.getDynamicPageName('provider-card');

              // this.searchResultService.getSearchResultJson("../../assets/hbs_partials/provider-card-partial.hbs").subscribe(response => {
              this.searchResultData = this.tenantConfigServiceV2.getTenantBluePrint({page_name: pageName , tenant: CURRENT_TENNANT,'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en'})
                .subscribe((response) => {
                  if(response == null) return;
                  let res = decodeURIComponent(Array.prototype.map.call(atob(response), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
                const template = Handlebars.compile(res);
                const renderedHtml = template({
                  providerSearchResults: this.providerCardDataArray,
                  totalProviderSearchResults: this.providerFilterSearchResults?.total,
                  facilitySearchResults: this.facilityCardDataArray,
                  totalFacilitySearchResults: this.facilityFilterSearchResults?.total,
                  isTeleHealthValue: isTeleHealthValue,
                  isPreciseLocationChecked: isPreciseLocationChecked
                });
                let data = JSON.parse(renderedHtml);
                if (tabProviderCardContainerRef.children.length > 0) {
                  tabProviderCardContainerRef.children.forEach(async (childUk: string) => {
                    var childGm = this.gmList.gmList[childUk];
                    await childGm.reference.clearForDestroy();
                  });
                  tabProviderCardContainerRef.children = [];
                  // resultsTabsRef.tabs = [];
                  tabProviderCardContainerRef.addChildrenToThisView(data);
                }
              })
            }

            console.log("providerSearchResults");
            console.log(this.providerSearchResults);
          },
          error: (err) => {
            console.error('Error while fetching provider results:', err);
            if (err.status === 500) {
              // handle 500 Internal Server Error

            } else {
              // handle other HTTP errors

            }

            // Optionally, close overlay or clean up
            // this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          },
          complete: () => {
            // this.loadingSpinnerService.hideLoader();
            // this.isLoading = false;
            setTimeout(() => {
              this.overlay.destroyOverlay(cfMainUk, cfMainUk);
            }, 700);
          }
        });

      } else {
        let tabParentUk = this.lobhelper.getDesiredParentUK(group[0].parentToChangePage, "tab_facility");
        let tabFacilityCardContainerUk = this.lobhelper.getDesiredChildUK(tabParentUk, "tab_facility_container");
        let tabFacilityCardContainerRef = this.gmList.gmList[tabFacilityCardContainerUk].reference;
        this.itemsPerPageFacility = group[0].pageSize;
        let currentPage = group[0].pageClicked;
        const skip = (currentPage - 1) * this.itemsPerPageFacility;

        const queryParams = {
          ...omitBy(this.searchStateService.getSearchCriteria().Query, isNull),
          skip: skip,
          limit: this.itemsPerPageFacility,
        };

        let isPreciseLocationChecked: boolean | undefined = undefined;
        if ('isPreciseLocation' in queryParams) {
          isPreciseLocationChecked = Boolean(queryParams.isPreciseLocation);
        }

        const { isTeleHealthValue } = this.getTelehealthFilterStatus();

        this.searchV2Service.getFacilityResults(queryParams).subscribe({
          next: (results) => {
            this.facilitySearchResults = results;
            if (this.facilitySearchResults?.facilities) {
              this.facilityCardDataArray = {
                facilities: this.mapSearchResults<AggregateRootOfFacilityOrganizationAffiliationV2>(
                  this.facilitySearchResults.facilities,
                  (item) => this.searchCardAdapter.adaptFacility(item)
                )
              };
              const templateMap: { [key: string]: string } = {
                villagecare: 'villagecare-facility-card',
                centerlight: 'centerlight-facility-card',
                mddoh: 'mddoh-facility-card'
              };
              // this.searchResultService.getSearchResultJson("../../assets/hbs_partials/facility-card-partial.hbs").subscribe(response => {
                this.searchResultData = this.tenantConfigServiceV2.getTenantBluePrint({
                  page_name: templateMap[CURRENT_TENNANT] || 'facility-card',
                  tenant: CURRENT_TENNANT,
                  'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en'
                })
                  .subscribe(response => {
                    if(response == null) return;
                    let res = decodeURIComponent(Array.prototype.map.call(atob(response), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
                const template = Handlebars.compile(res);
                const renderedHtml = template({
                  facilitySearchResults: this.facilityCardDataArray,
                  isPreciseLocationChecked: isPreciseLocationChecked,
                  isTeleHealthValue: isTeleHealthValue,
                });
                let data = JSON.parse(renderedHtml);
                if (tabFacilityCardContainerRef.children.length > 0) {
                  tabFacilityCardContainerRef.children.forEach(async (childUk: string) => {
                    var childGm = this.gmList.gmList[childUk];
                    await childGm.reference.clearForDestroy();
                  });
                  tabFacilityCardContainerRef.children = [];
                  // resultsTabsRef.tabs = [];
                  tabFacilityCardContainerRef.addChildrenToThisView(data);
                }
              })
            }

            console.log("facilitySearchResults");
            console.log(this.facilitySearchResults);
          },
          complete: () => {
            // this.loadingSpinnerService.hideLoader();
            // this.isLoading = false;
            setTimeout(() => {
              this.overlay.destroyOverlay(cfMainUk, cfMainUk);
            }, 700);
          },
        });
      }
    }
  }

  private async seedDefaultVillageCareLocation(): Promise<void> {
    if (CURRENT_TENNANT !== 'villagecare') {
      return;
    }

    const currentState = this.searchStateService.getSearchCriteria();
    if (
      currentState.Extra.locationText ||
      currentState.Extra.locationSource === 'user' ||
      currentState.Extra.locationSource === 'cleared'
    ) {
      return;
    }

    try {
      const defaultLocation = await this.defaultLocationService.getVillageCareDefaultLocation();
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...currentState.Query,
          location: {
            ...currentState.Query.location,
            latitude: defaultLocation.latitude,
            longitude: defaultLocation.longitude,
            distance: currentState.Query.location?.distance ?? '100',
          },
        },
        Extra: {
          ...currentState.Extra,
          locationText: defaultLocation.formattedAddress,
          locationSource: 'default',
        },
      });
    } catch (error) {
      console.warn('Unable to seed default VillageCare location:', error);
    }
  }

}
